<template>

    <div class="studio-booking ksr-booking" id="booking-container">

        <!--<div v-if="rootSection == 'dokdebug'" class="px-4">
            <KSRUploadDocuments :kit="kit" :storeId="studioId" :jobId="13468" />
        </div>-->

        <div v-if="rootSection == 'singlejob'">
            <KSRSingleJob @eventname="updatejobdata" :storeId="studioId" />
        </div>

        <div class="mb-4 ksr-booking--head" v-if="!kit && rootSection != 'singlejob'">

            <p v-if="content.guest_welcome_header" class="mb-1 ksr-booking--title" v-html="content.guest_welcome_header"></p>

            <div class="ksr-booking--nav" v-if="!singleTokenActive && !content.setting_guestbooking">
                <span v-if="content.setting_kl">
                    <a :href="storeUrl" :class="{ active: rootSection == 'kl' }">
                        <!-- user content -->
                        <span v-if="content.guest_navigation_item_kl" v-html="content.guest_navigation_item_kl"></span>
                    </a>
                </span>
                <span v-if="content.setting_service">
                    <a href="javascript:void(0);" @click="rootSection = 'mechanik', service_reload++" :class="{ active: rootSection == 'mechanik' }">
                        <!-- user content -->
                        <span v-if="content.guest_navigation_item_service" v-html="content.guest_navigation_item_service"></span>
                    </a>
                </span>
                <a href="javascript:void(0);" @click="openLoginWindow()">Anmelden</a>
            </div>

            <div class="ksr-booking--nav" v-if="!singleTokenActive && content.setting_guestbooking">
                <span v-if="content.setting_kl">
                    <a :href="storeUrl" :class="{ active: $router && !['service', 'service-checkout', 'service-form'].includes($route.name) }">
                        <!-- user content -->
                        <span v-if="content.guest_navigation_item_kl" v-html="content.guest_navigation_item_kl"></span>
                    </a>
                </span>
                <span v-if="content.setting_service">
                  <router-link to="/service" :class="{ active: $router && ['service', 'service-checkout', 'service-form'].includes($route.name) }">
                      <!-- user content -->
                      <span v-if="content.guest_navigation_item_service" v-html="content.guest_navigation_item_service"></span>
                  </router-link>
                </span>
            </div>

        </div>


        <div v-if="kit && rootSection != 'singlejob'" class="mb-4 ksr-booking--head">
            <div class="mb-3 d-flex justify-content-between align-items-center">
                <div class="mb-0">
                    <i class="fa fa-user-circle mr-2" aria-hidden="true"></i>
                    <span class="ksr-booking--title" v-if="accountInfoFull && (accountInfoFull.customerIdentity.salutation && accountInfoFull.customerIdentity.lastName)"><span class="d-none d-sm-inline">Hallo</span> {{ accountInfoFull.customerIdentity.salutation }} {{ accountInfoFull.customerIdentity.lastName }}</span>
                    <span class="ksr-booking--title" v-else="">...</span>
                </div>
                <div>
                    <a href="javascript:void(0)" @click="onEditAccount()" v-bind:class="{ active: editAccount }">
                        <span class="d-none d-sm-inline">Mein</span> Profil
                        <span class="d-inline-block ml-1">
                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" class="svg-icon" style="margin-top:-1px">
                                <g clip-path="url(#clip0_2_578)">
                                <path d="M12 15C13.6569 15 15 13.6569 15 12C15 10.3431 13.6569 9 12 9C10.3431 9 9 10.3431 9 12C9 13.6569 10.3431 15 12 15Z" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                <path d="M19.4 15C19.2669 15.3016 19.2272 15.6362 19.286 15.9606C19.3448 16.285 19.4995 16.5843 19.73 16.82L19.79 16.88C19.976 17.0657 20.1235 17.2863 20.2241 17.5291C20.3248 17.7719 20.3766 18.0322 20.3766 18.295C20.3766 18.5578 20.3248 18.8181 20.2241 19.0609C20.1235 19.3037 19.976 19.5243 19.79 19.71C19.6043 19.896 19.3837 20.0435 19.1409 20.1441C18.8981 20.2448 18.6378 20.2966 18.375 20.2966C18.1122 20.2966 17.8519 20.2448 17.6091 20.1441C17.3663 20.0435 17.1457 19.896 16.96 19.71L16.9 19.65C16.6643 19.4195 16.365 19.2648 16.0406 19.206C15.7162 19.1472 15.3816 19.1869 15.08 19.32C14.7842 19.4468 14.532 19.6572 14.3543 19.9255C14.1766 20.1938 14.0813 20.5082 14.08 20.83V21C14.08 21.5304 13.8693 22.0391 13.4942 22.4142C13.1191 22.7893 12.6104 23 12.08 23C11.5496 23 11.0409 22.7893 10.6658 22.4142C10.2907 22.0391 10.08 21.5304 10.08 21V20.91C10.0723 20.579 9.96512 20.258 9.77251 19.9887C9.5799 19.7194 9.31074 19.5143 9 19.4C8.69838 19.2669 8.36381 19.2272 8.03941 19.286C7.71502 19.3448 7.41568 19.4995 7.18 19.73L7.12 19.79C6.93425 19.976 6.71368 20.1235 6.47088 20.2241C6.22808 20.3248 5.96783 20.3766 5.705 20.3766C5.44217 20.3766 5.18192 20.3248 4.93912 20.2241C4.69632 20.1235 4.47575 19.976 4.29 19.79C4.10405 19.6043 3.95653 19.3837 3.85588 19.1409C3.75523 18.8981 3.70343 18.6378 3.70343 18.375C3.70343 18.1122 3.75523 17.8519 3.85588 17.6091C3.95653 17.3663 4.10405 17.1457 4.29 16.96L4.35 16.9C4.58054 16.6643 4.73519 16.365 4.794 16.0406C4.85282 15.7162 4.81312 15.3816 4.68 15.08C4.55324 14.7842 4.34276 14.532 4.07447 14.3543C3.80618 14.1766 3.49179 14.0813 3.17 14.08H3C2.46957 14.08 1.96086 13.8693 1.58579 13.4942C1.21071 13.1191 1 12.6104 1 12.08C1 11.5496 1.21071 11.0409 1.58579 10.6658C1.96086 10.2907 2.46957 10.08 3 10.08H3.09C3.42099 10.0723 3.742 9.96512 4.0113 9.77251C4.28059 9.5799 4.48572 9.31074 4.6 9C4.73312 8.69838 4.77282 8.36381 4.714 8.03941C4.65519 7.71502 4.50054 7.41568 4.27 7.18L4.21 7.12C4.02405 6.93425 3.87653 6.71368 3.77588 6.47088C3.67523 6.22808 3.62343 5.96783 3.62343 5.705C3.62343 5.44217 3.67523 5.18192 3.77588 4.93912C3.87653 4.69632 4.02405 4.47575 4.21 4.29C4.39575 4.10405 4.61632 3.95653 4.85912 3.85588C5.10192 3.75523 5.36217 3.70343 5.625 3.70343C5.88783 3.70343 6.14808 3.75523 6.39088 3.85588C6.63368 3.95653 6.85425 4.10405 7.04 4.29L7.1 4.35C7.33568 4.58054 7.63502 4.73519 7.95941 4.794C8.28381 4.85282 8.61838 4.81312 8.92 4.68H9C9.29577 4.55324 9.54802 4.34276 9.72569 4.07447C9.90337 3.80618 9.99872 3.49179 10 3.17V3C10 2.46957 10.2107 1.96086 10.5858 1.58579C10.9609 1.21071 11.4696 1 12 1C12.5304 1 13.0391 1.21071 13.4142 1.58579C13.7893 1.96086 14 2.46957 14 3V3.09C14.0013 3.41179 14.0966 3.72618 14.2743 3.99447C14.452 4.26276 14.7042 4.47324 15 4.6C15.3016 4.73312 15.6362 4.77282 15.9606 4.714C16.285 4.65519 16.5843 4.50054 16.82 4.27L16.88 4.21C17.0657 4.02405 17.2863 3.87653 17.5291 3.77588C17.7719 3.67523 18.0322 3.62343 18.295 3.62343C18.5578 3.62343 18.8181 3.67523 19.0609 3.77588C19.3037 3.87653 19.5243 4.02405 19.71 4.21C19.896 4.39575 20.0435 4.61632 20.1441 4.85912C20.2448 5.10192 20.2966 5.36217 20.2966 5.625C20.2966 5.88783 20.2448 6.14808 20.1441 6.39088C20.0435 6.63368 19.896 6.85425 19.71 7.04L19.65 7.1C19.4195 7.33568 19.2648 7.63502 19.206 7.95941C19.1472 8.28381 19.1869 8.61838 19.32 8.92V9C19.4468 9.29577 19.6572 9.54802 19.9255 9.72569C20.1938 9.90337 20.5082 9.99872 20.83 10H21C21.5304 10 22.0391 10.2107 22.4142 10.5858C22.7893 10.9609 23 11.4696 23 12C23 12.5304 22.7893 13.0391 22.4142 13.4142C22.0391 13.7893 21.5304 14 21 14H20.91C20.5882 14.0013 20.2738 14.0966 20.0055 14.2743C19.7372 14.452 19.5268 14.7042 19.4 15Z" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                </g>
                                <defs>
                                <clipPath id="clip0_2_578">
                                <rect width="24" height="24" fill="white"/>
                                </clipPath>
                                </defs>
                            </svg>
                        </span>
                    </a>
                </div>
            </div>
            <div v-if="requestId || content.setting_service">
                <div class="ksr-booking--nav" v-if="!singleTokenActive">
                    <span v-if="content.setting_kl">
                        <a href="/" :href="storeUrl" v-bind:class="{ active: (!editAccount && !currentPage && !kitShowLicensePlateInput && rootSection === 'kl' && !['service', 'service-checkout', 'service-form'].includes($route.name)) || ($route && $route.path === '/viewing-appointment-checkout/create') }">
                            <!-- user content -->
                            <span v-if="content.authenticated_navigation_item_kl" v-html="content.authenticated_navigation_item_kl"></span>
                        </a>
                    </span>
                    <span v-if="content.setting_service">
                        <a href="javascript:void(0);" @click="kitOnService()" :class="{ active: rootSection === 'mechanik' || ($router && ['service', 'service-checkout', 'service-form'].includes($route.name)) }">
                            <!-- user content -->
                            <span v-if="content.authenticated_navigation_item_service" v-html="content.authenticated_navigation_item_service"></span>
                        </a>
                    </span>
                    <a href="javascript:void(0)" @click="kitOnListCurrentJobs()" v-bind:class="{ active: (currentPage == 'currentJobs' || currentPage == 'jobDetails') && !editAccount }">Meine Aufträge</a>
                </div>
            </div>
        </div>

        <div v-if="rootSection != 'singlejob'" class="ksr-booking--body">

            <div class="row">

                <div class="col-sm-12">

                    <div class="spinner-border text-primary mr-2" role="status" v-if="loadingEmployeeCalender">
                      <span class="sr-only">Loading...</span>
                    </div>

                    <!--<p>Router available: {{ !!$router }}</p>
                    <p>Current route: {{ $route ? $route.path : 'No route' }}</p>
                    <p>Route name: {{ $route ? $route.name : 'No route name' }}</p>
                    <p>rootSection = {{ rootSection }}</p>-->

                    <div v-if="rootSection == 'mechanik'">
                        <KSRMechanik :kit="kit" :storeId="studioId" :key="service_reload" />
                        <!-- @insurance-data-completed="getInsuranceData" :initInsuranceData="initInsuranceData"  -->
                    </div>

                    <div v-else-if="rootSection == 'vehicles'">
                        <KSRVehicles :kit="kit" :storeId="studioId" :key="service_reload" />
                        <!-- @insurance-data-completed="getInsuranceData" :initInsuranceData="initInsuranceData"  -->
                    </div>

                    <div v-else-if="rootSection == 'damagerecording'">
                        <KSRDamageRecording :kit="kit" :storeId="studioId" :key="" />
                    </div>

                    <div v-else-if="rootSection == 'uploadDocuments'">
                        <KSRUploadDocuments :kit="kit" :damageToken="damageToken" :storeId="studioId" :jobId="jobId" :content="content" ref="uploadDocumentsChild" />
                    </div>

                    <div v-else-if="rootSection == 'guestBookingViewingAppointment'">
                      <div v-if="!insuranceData">
                        <Insurance @insurance-data-completed="getInsuranceDataCheckout" :initInsuranceData="initInsuranceData" />
                      </div>
                    </div>

                    <!-- Guest Booking routes -->
                    <div v-else-if="$router && (
                        ['viewing-appointment',
                        'viewing-appointment-checkout',
                        'viewing-appointment-form',
                        'phone-verification',
                        'thank-you',
                        'online-offer',
                        'online-offer-checkout',
                        'online-offer-form',
                        'service',
                        'service-checkout',
                        'service-form'].includes($route.name))">
                      <router-view></router-view>
                    </div>

                    <div v-else>

                        <div v-if="currentPage == 'currentJobs'">
                            <div class="mb-4">
                                <h5 class="mb-4">Meine Aufträge</h5>
                                <!-- user content -->
                                <div v-if="content.authenticated_myjobs" class="c1 mb-4" v-html="content.authenticated_myjobs"></div>
                                <div class="spinner-border text-primary mr-2" role="status" v-if="loading && !accountInfoJobs">
                                    <span class="sr-only">Loading...</span>
                                </div>
                                <ul class="list-unstyled" id="jobs">
                                    <li v-for="job in accountInfoJobs" class="job" @click="onJobDetails(job.jobKey.jobId)">
                                        <div class="d-flex justify-content-between" :class="jobIdLoading && jobIdLoading != job.jobKey.jobId ? 'no-focus' : ''">
                                            <div>
                                                <strong>Auftrags-Nr.: {{ job.jobKey.jobId }}</strong><br />
                                                <div class="job-details">
                                                    <!-- Zeile 1 -->
                                                    <span>Kennzeichen: {{ job.vehicle.licensePlate }} | {{ job.vehicle.manufacturer }} {{ job.vehicle.model }} {{ job.vehicle.model }} {{ job.vehicle.type }}</span>
                                                    <!-- Zeile 2 -->
                                                    <span v-if="job.progressInfo.progress == 30">Erfasst</span>
                                                    <span v-if="job.progressInfo.progress == 40">Angebot erstellt</span>
                                                    <span v-if="job.progressInfo.progress == 50 || job.progressInfo.progress == 90">Beauftragt</span>
                                                    <span v-if="job.progressInfo.progress == 100">Fakturiert</span>
                                                    <!-- Zeile 3 -->
                                                    <span v-if="job.progressInfo.vehicleState == 30 || job.progressInfo.vehicleState == 70">Kein Termin vereinbart</span>
                                                    <span v-if="job.progressInfo.vehicleState == 5">Besichtigung vereinbart</span>
                                                    <span v-if="job.progressInfo.vehicleState == 10 || job.progressInfo.vehicleState == 20">Termin vereinbart</span>
                                                    <span v-if="job.progressInfo.vehicleState == 40">Fahrzeug ist bei uns</span>
                                                    <span v-if="job.progressInfo.vehicleState == 50">Fahrzeug ist fertig zur Abholung</span>
                                                    <span v-if="job.progressInfo.vehicleState == 60">Fahrzeug ist ausgeliefert</span>
                                                    <!--<span v-if="job.progressInfo.vehicleState == 5">Besichtigung vereinbart</span>
                                                    <span v-if="job.progressInfo.vehicleState == 10">Termin vereinbart</span>
                                                    <span v-if="job.progressInfo.vehicleState == 20">Termin vereinbart nach Vorarbeiten</span>
                                                    <span v-if="job.progressInfo.vehicleState == 30">Auf Abruf</span>
                                                    <span v-if="job.progressInfo.vehicleState == 40">Fahrzeug im Haus</span>
                                                    <span v-if="job.progressInfo.vehicleState == 50">Fahrzeug fertig zur Abholung</span>
                                                    <span v-if="job.progressInfo.vehicleState == 60">Fahrzeug abgeholt</span>
                                                    <span v-if="job.progressInfo.vehicleState == 70">Teileauftrag</span>-->
                                                    <!-- Zeile 4 -->
                                                    <span v-if="job.progressInfo.additionalState == 10 || job.progressInfo.additionalState == 100 || job.progressInfo.additionalState == 110 || job.progressInfo.additionalState == 101 || job.progressInfo.additionalState == 111 || job.progressInfo.additionalState == 121 || job.progressInfo.additionalState == 131">Ersatzwagen</span>
                                                    <span v-if="job.progressInfo.additionalState == 40 || job.progressInfo.additionalState == 41">Warten auf Fertigstellung</span>
                                                    <span v-if="job.progressInfo.additionalState == 1 || job.progressInfo.additionalState == 11 || job.progressInfo.additionalState == 21 || job.progressInfo.additionalState == 31 || job.progressInfo.additionalState == 41 || job.progressInfo.additionalState == 111 || job.progressInfo.additionalState == 121 || job.progressInfo.additionalState == 131">Direktannahme</span>
                                                    <a class="cursor-pointer">Auftrag anzeigen</a>
                                                    <!--<a class="cursor-pointer" @click="onViewingAppointmentWithJobId(job.vehicle.licensePlate, job.jobKey.jobId)">weitere Aktionen <i class="fa fa-angle-right" aria-hidden="true"></i></a>-->
                                                    <!--<a class="cursor-pointer" @click="onOnlineOfferWithJobId(job.jobKey.jobId)">Onlineangebot anfordern</a>-->
                                                </div>
                                            </div>
                                            <div>
                                                <div class="spinner-border text-primary mr-2" role="status" v-if="jobIdLoading == job.jobKey.jobId">
                                                    <span class="sr-only">Loading...</span>
                                                </div>
                                                <div v-else>
                                                    <i class="fa fa-wrench" aria-hidden="true"></i>
                                                </div>
                                            </div>
                                        </div>
                                        <!--JobId: {{ job.jobKey }}<br />
                                        ProgressInfo: {{ job.progressInfo }}-->
                                    </li>
                                </ul>
                            </div>
                        </div>

                        <div v-if="currentPage == 'jobDetails'">
                            <div class="mb-4">
                                <h5 class="mb-2">Unsere Referenz-Nr.: {{ jobId }}</h5>
                                <div class="spinner-border text-primary mr-2" role="status" v-if="loading">
                                    <span class="sr-only">Loading...</span>
                                </div>
                                <div class="job-details mb-2">
                                    <!-- Zeile 1 -->
                                    <span>Kennzeichen: {{ jobData.value.vehicle.registrationDetails.registrationPlate }}<br />
                                    {{ jobData.value.vehicle.typeDetails.manufacturer }} {{ jobData.value.vehicle.typeDetails.model }} {{ jobData.value.vehicle.typeDetails.productionSeries }}</span>
                                    <!-- Zeile 2 -->
                                    <span v-if="jobData.value.progressInfo.progress == 30">Erfasst</span>
                                    <span v-if="jobData.value.progressInfo.progress == 40">Angebot erstellt</span>
                                    <span v-if="jobData.value.progressInfo.progress == 50 || jobData.value.progressInfo.progress == 90">Beauftragt</span>
                                    <span v-if="jobData.value.progressInfo.progress == 100">Fakturiert</span>
                                </div>
                                <div class="row">
                                    <div class="col-sm-4"><i class="fa fa-info-circle" aria-hidden="true"></i> {{ jobData.value.progressInfo.textLeft }}</div>
                                    <div class="col-sm-4"><img :src="jobData.value.progressInfo.imageUri" class="img-fluid" :alt="jobData.value.progressInfo.imageText"><br />{{ jobData.value.progressInfo.imageText }}</div>
                                    <div class="col-sm-4">{{ jobData.value.progressInfo.textRight }}</div>
                                </div>
                                <div>
                                    <!--<p>
                                        Kennzeichen: <strong>{{ jobData.value.vehicle.registrationDetails.registrationPlate }}</strong><br />
                                {{ jobData.value.vehicle.typeDetails.manufacturer }}, {{ jobData.value.vehicle.typeDetails.model }} (Status: {{ jobData.value.progressInfo.progress }})</p>-->
                                    <h6>Sie haben folgende Optionen:</h6>
                                    <div v-if="content.setting_kl !== 0">
                                      <button class="btn btn-primary my-1 mr-1" @click="onViewingAppointmentFromJob()" v-if="jobData.value.progressInfo.progress == 30 && (jobData.value.progressInfo.vehicleState < 10 || jobData.value.progressInfo.vehicleState == 70)">Besichtigungstermin vereinbaren</button>
                                    </div>
                                    <!--<button class="btn btn-primary my-1 mr-1" @click="onOnlineOfferFromJob()" v-if="jobData.value.progressInfo.progress == 30">Onlineangebot anfordern</button>-->
                                    <button class="btn btn-primary my-1 mr-1" @click="onOnlineOfferDocuments()" v-if="jobData.value.progressInfo.progress >= 30 && jobData.value.progressInfo.progress <= 50">Bilder und Dokumente übertragen</button>
                                    <hr />
                                    <KSRMessageToBodyshop :storeId="studioId" :jobId="jobId" :kit="kit" />
                                </div>
                            </div>
                        </div>

                        <VueSlickCarousel v-bind="slicksettings" ref="carousel" v-if="(!editAccount && !currentPage) || currentPage == 'jobDetails'" v-show="!hideSlick">

                            <div class="slide">

                                <div v-if="currentPage !== 'jobDetails'">

                                    <div v-if="hideFirstPage && !kit"> <!-- show loader if first page is hidden, e.g. when coming from a single job view -->
                                        <div class="spinner-border text-primary mr-2" role="status">
                                            <span class="sr-only">Loading...</span>
                                        </div>
                                    </div>

                                    <div v-if="!kit && !hideFirstPage">

                                        <div v-if="!content.setting_guestbooking">

                                          <!-- user content -->
                                          <div v-if="content.welcome_greeting" class="c1 mb-2" v-html="content.welcome_greeting"></div>

                                          <div class="licenseplate-input">

                                              <h5 class="mb-2">Bitte geben Sie Ihr Kennzeichen ein</h5>

                                              <div class="form-group">
                                                  <input type="text" v-model="licenseplate" class="form-control licenseplate" maxlength="12" placeholder="M-CN 1234" @keyup="formatLicensePlate" @keyup.enter="onLicensePlateInput()">
                                              </div>

                                              <button class="btn btn-primary mt-1 mb-2 mr-1" @click="onLicensePlateInput()" :disabled="!licenseplateValid">
                                                  <div class="spinner-border text-white mr-2" role="status" v-if="loading">
                                                      <span class="sr-only">Loading...</span>
                                                  </div>
                                                  <i class="fa fa-search" aria-hidden="true"></i> Kennzeichen suchen
                                              </button>

                                          </div>

                                        </div>

                                        <div v-if="content.setting_guestbooking">

                                          <div v-if="(content.setting_kl == 0 && content.setting_service == 1)">

                                            <router-link to="/service" :class="{ active: $router && ['service'].includes($route.name) }">
                                              <!-- user content -->
                                              <span v-if="content.guest_navigation_item_service" v-html="content.guest_navigation_item_service"></span>
                                            </router-link>

                                          </div>
                                          <div v-else>

                                            <!-- user content -->
                                            <div v-if="content.welcome_greeting_guestbooking" class="c1 mb-2" v-html="content.welcome_greeting_guestbooking"></div>

                                            <button class="btn btn-primary my-1 mr-1 mb-3" @click="goToKSRViewingAppointment">Besichtigungstermin buchen</button>
                                            <button class="btn btn-primary my-1 mr-1 mb-3" @click="goToKSROnlineOffer" v-if="content.setting_onlineoffer">Onlineangebot anfordern</button>

                                          </div>

                                          <br /><br />

                                        </div>

                                        <div v-if="!content.setting_guestbooking">
                                          <!-- user content -->
                                          <div v-if="content.welcome_beforelicenseplate" class="c2 mb-4" v-html="content.welcome_beforelicenseplate"></div>
                                        </div>

                                        <div class="infobox fade show mt-2" role="alert" v-if="error">
                                            <h5 v-if="error !== 'Bitte treffen Sie eine Auswahl:'">Kein Auftrag gefunden.</h5>
                                            <!-- user content -->
                                            <div v-if="content.welcome_licenseplatenotfound" class="c2 mb-4" v-html="content.welcome_licenseplatenotfound"></div>
                                            <!--<p>{{ error }}</p>
                                            <div v-if="!kit">
                                                <p>Um einen neuen Auftrag zu erstellen müssen Sie sich <a href="javascript:void(0)" @click="openLoginWindow()">anmelden</a>.</p>
                                            </div>
                                            <div v-else>
                                                <p>Auftrag anlegen</p>
                                            </div>-->
                                        </div>

                                        <div class="infobox fade show mt-2" v-if="licenseplateFound">
                                            <h5>Auftrag gefunden</h5>
                                            <!-- user content -->
                                            <div v-if="content.welcome_licenseplatefound" class="c2 mb-1" v-html="content.welcome_licenseplatefound"></div>
                                            <button class="btn btn-primary mt-2 mb-2 mr-1" @click="onViewingAppointment()" v-if="progress == 30 && (progressInfo.vehicleState < 10 || progressInfo.vehicleState == 70)">Besichtigungstermin vereinbaren</button>
                                            <!--<button class="btn btn-primary mr-1" @click="onOnlineOffer()" v-if="content.setting_onlineoffer">Onlineangebot anfordern</button>-->
                                            <button class="btn btn-primary my-1 mr-1" @click="onOnlineOfferDocuments()" v-if="progress >= 30 && progress <= 50">Bilder und Dokumente übertragen</button> <!-- v-if="jobData.value.progressInfo.progress >= 30 && jobData.value.progressInfo.progress <= 50" -->
                                        </div>

                                        <!--<div class="text-right">
                                            <a href="javascript:void(0)" @click="openLoginWindow()" class="font-bold" v-if="thirdPartyCookiesSupported">
                                                <span class="mr-1">Anmelden</span>
                                                <svg class="svg-icon" width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M20 1L18 3M18 3L21 6L17.5 9.5L14.5 6.5M18 3L14.5 6.5M10.39 10.61C10.9064 11.1195 11.3168 11.726 11.5978 12.3948C11.8787 13.0635 12.0246 13.7813 12.0271 14.5066C12.0295 15.232 11.8884 15.9507 11.6119 16.6213C11.3355 17.2919 10.9291 17.9012 10.4162 18.4141C9.90326 18.9271 9.29395 19.3334 8.62333 19.6099C7.95271 19.8864 7.23403 20.0275 6.50866 20.025C5.7833 20.0226 5.06557 19.8767 4.39682 19.5958C3.72807 19.3148 3.1215 18.9043 2.61203 18.388C1.61016 17.3507 1.05579 15.9614 1.06832 14.5193C1.08085 13.0772 1.65928 11.6977 2.67903 10.678C3.69877 9.65825 5.07824 9.07982 6.52032 9.06729C7.96241 9.05476 9.35172 9.60913 10.389 10.611L10.39 10.61ZM10.39 10.61L14.5 6.5" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                                </svg>
                                            </a>
                                            <a :href="storeUrl" target="_blank" class="font-bold" v-if="!thirdPartyCookiesSupported">
                                                <span class="mr-1">Anmelden</span>
                                                <svg class="svg-icon" width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M20 1L18 3M18 3L21 6L17.5 9.5L14.5 6.5M18 3L14.5 6.5M10.39 10.61C10.9064 11.1195 11.3168 11.726 11.5978 12.3948C11.8787 13.0635 12.0246 13.7813 12.0271 14.5066C12.0295 15.232 11.8884 15.9507 11.6119 16.6213C11.3355 17.2919 10.9291 17.9012 10.4162 18.4141C9.90326 18.9271 9.29395 19.3334 8.62333 19.6099C7.95271 19.8864 7.23403 20.0275 6.50866 20.025C5.7833 20.0226 5.06557 19.8767 4.39682 19.5958C3.72807 19.3148 3.1215 18.9043 2.61203 18.388C1.61016 17.3507 1.05579 15.9614 1.06832 14.5193C1.08085 13.0772 1.65928 11.6977 2.67903 10.678C3.69877 9.65825 5.07824 9.07982 6.52032 9.06729C7.96241 9.05476 9.35172 9.60913 10.389 10.611L10.39 10.61ZM10.39 10.61L14.5 6.5" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                                </svg>
                                            </a>
                                        </div>

                                        third party cookies are <span id="result"/></span>
                                        <iframe src="https://booklyn.io/3rdpartycookiecheck/start.html" class="d-none" />
                                        -->

                                        <div class="text-right">
                                            <a href="javascript:void(0)" @click="openLoginWindow()" class="font-bold">
                                                <span class="mr-1">Anmelden</span>
                                                <svg class="svg-icon" width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M20 1L18 3M18 3L21 6L17.5 9.5L14.5 6.5M18 3L14.5 6.5M10.39 10.61C10.9064 11.1195 11.3168 11.726 11.5978 12.3948C11.8787 13.0635 12.0246 13.7813 12.0271 14.5066C12.0295 15.232 11.8884 15.9507 11.6119 16.6213C11.3355 17.2919 10.9291 17.9012 10.4162 18.4141C9.90326 18.9271 9.29395 19.3334 8.62333 19.6099C7.95271 19.8864 7.23403 20.0275 6.50866 20.025C5.7833 20.0226 5.06557 19.8767 4.39682 19.5958C3.72807 19.3148 3.1215 18.9043 2.61203 18.388C1.61016 17.3507 1.05579 15.9614 1.06832 14.5193C1.08085 13.0772 1.65928 11.6977 2.67903 10.678C3.69877 9.65825 5.07824 9.07982 6.52032 9.06729C7.96241 9.05476 9.35172 9.60913 10.389 10.611L10.39 10.61ZM10.39 10.61L14.5 6.5" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                                </svg>
                                            </a>
                                        </div>

                                    </div>

                                    <div class="spinner-border text-primary mr-2" role="status" v-if="kit && !requestId">
                                        <span class="sr-only">Loading...</span>
                                    </div>

                                    <div v-if="kit && requestId">

                                        <div v-if="kitShowLicensePlateInput">
                                            <div class="form-group">
                                                <h5 class="mb-4">Auftragssuche nach Kennzeichen</h5>
                                                <label class="form-label">Ihr Kennzeichen:</label>
                                                <input type="text" v-model="licenseplate" class="form-control licenseplate" maxlength="12" placeholder="M-CN 1234" @keyup="formatLicensePlate" @keyup.enter="onLicensePlateInput()">
                                            </div>
                                            <button class="btn btn-primary my-3 mr-1" @click="onLicensePlateInput()" :disabled="!licenseplateValid">
                                                <div class="spinner-border text-white mr-2" role="status" v-if="loading">
                                                    <span class="sr-only">Loading...</span>
                                                </div>
                                                <i class="fa fa-search" aria-hidden="true"></i> Kennzeichen suchen
                                            </button>
                                            <div class="infobox fade show mt-2" v-if="licenseplateFound">
                                                <h5>Auftrag gefunden</h5>
                                                <!-- user content -->
                                                <div v-if="content.welcome_licenseplatefound" class="c2 mb-1" v-html="content.welcome_licenseplatefound"></div>
                                                <button class="btn btn-primary my-3 mr-1" @click="onViewingAppointment()">Besichtigungstermin vereinbaren</button>
                                                <button class="btn btn-primary my-3 mr-1" @click="onOnlineOffer()" v-if="content.setting_onlineoffer">Onlineangebot anfordern</button>
                                            </div>
                                            <hr />
                                            <a href="javascript:void(0)" @click="onKitToggleLicensePlateInput()">Zurück</a>
                                        </div>

                                        <div v-if="!kitShowLicensePlateInput">
                                            <h5 class="mb-4">Neue Anfrage</h5>
                                            <!-- user content -->
                                            <div v-if="content.authenticated_newrequest" class="c1 mb-4" v-html="content.authenticated_newrequest"></div>
                                            <button class="btn btn-primary mb-2 mr-1" @click="onViewingAppointment()">Besichtigungstermin vereinbaren</button>
                                            <button class="btn btn-primary mb-2" @click="onOnlineOffer()" v-if="content.setting_onlineoffer">Onlineangebot anfordern</button>
                                        </div>

                                    </div>

                                </div>

                            </div> <!-- /.slide -->

                            <div class="slide">

                                <div v-if="(kit || licenseplateFound) && !onlineOffer">

                                    <h5>Besichtigungstermin vereinbaren<span v-if="!kit">: Tag und Uhrzeit auswählen</span></h5>

                                    <div v-if="!kit || (kit && licenseplate !== 'k')">

                                        <div v-if="typeDetails" class="reviewbox relative mb-2" v-show="(licenseplate && licenseplate != '0') || typeDetails.manufacturer">
                                            <h5>Ihr Fahrzeug</h5>
                                            <p v-if="licenseplate && licenseplate != '0'" class="mb-0">Kennzeichen: <strong>{{ licenseplate }}</strong></p>
                                            <p v-if="typeDetails.manufacturer" class="mb-0">Hersteller: <strong>{{ typeDetails.manufacturer }}</strong></p>
                                            <p v-if="typeDetails.model" class="mb-0">Modell: <strong>{{ typeDetails.model }}</strong></p>
                                            <!--<p v-if="typeDetails.vin" class="mb-0">VIN / Fahrgestellnummer: <strong>{{ typeDetails.vin }}</strong></p>-->
                                            <div class="vehicle-img">
                                                <!--<img src="/images/hyundai.png" class="img-fluid">-->
                                            </div>
                                        </div>

                                    </div>

                                    <div v-else>

                                        <div v-show="!insuranceData">
                                            <!--<p class="mt-3">Um einen neuen Besichtigungstermin zu vereinbaren benötigen wir von Ihnen folgende Angaben:</p>-->
                                            <!-- START abfrage versicherung -->
                                            <Insurance @insurance-data-completed="getInsuranceData" :initInsuranceData="initInsuranceData" />
                                            <!-- END abfrage versicherung -->
                                        </div>

                                        <div v-show="insuranceData || jobId">

                                            <!-- kit besichtigungstermin zusatzfelder -->
                                            <!--<p class="mb-2"><strong>Wir benötigen von Ihnen ein paar Angaben:</strong></p>-->
                                            <div class="insurance-data" v-if="insuranceData.damagetype">
                                                <h5>Ihre Angaben zur Versicherung</h5>
                                                <div v-if="insuranceData.damagetype">Haftpflicht oder Kasko? <strong>{{ insuranceData.damagetype }}</strong></div>
                                                <div v-if="insuranceData.company">Ihre Versicherung: <strong>{{ insuranceData.company }}</strong></div>
                                                <div v-if="insuranceData.reported">Schaden gemeldet? <strong>{{ insuranceData.reported }}</strong></div>
                                                <div v-if="insuranceData.hasdamagenumber">Schadennummer erhalten? <strong>{{ insuranceData.hasdamagenumber }}</strong></div>
                                                <div v-if="insuranceData.damagenumber">Schadennummer: <strong>{{ insuranceData.damagenumber }}</strong></div>
                                            </div>

                                            <div class="form-row" v-bind:class="{ 'active': insuranceData }">
                                                <div class="col-md-12">
                                                    <p><strong>Bitte ergänzen Sie noch folgende Daten zu Ihrem Fahrzeug:</strong></p>
                                                </div>
                                            </div>

                                            <!-- Besichtigungstermin Schaden kein Pflichtfeld -->

                                            <KSRSelectVehicle @setvehicle="setVehicle" :kit="kit" />

                                            <div class="invalid-feedback d-block invalid-vehicle" v-if="formdata_errors.includes('licenseplate')">
                                                Bitte wählen Sie ein Fahrzeug aus.
                                            </div>

                                            <div class="form-row">

                                                <div class="form-group col-md-12">
                                                    <label class="form-label" for="description">Schadenbeschreibung<span class="text-danger">*</span>:</label>
                                                    <textarea name="description" v-model="formdata.description" class="form-control" id="description"></textarea>
                                                    <p class="small text-muted" v-if="!formdata_errors.includes('description')">Bitte geben Sie hier eine möglichst präzise Beschreibung Ihres Schadens an.</p>
                                                    <div class="invalid-feedback d-block" v-if="formdata_errors.includes('description')">
                                                        Bitte geben Sie hier eine möglichst präzise Beschreibung Ihres Schadens an.
                                                    </div>
                                                </div>

                                            </div>

                                            <div class="form-group">
                                                <label class="form-label" for="Schadenbilder">Schadenbilder (JPG, PNG) - optional:</label>
                                                <vue-dropzone
                                                ref="myVueDropzone1"
                                                :useCustomSlot="true"
                                                id="dropzone"
                                                @vdropzone-upload-progress="uploadProgress"
                                                :options="dropzoneOptions"
                                                @vdropzone-file-added="fileAdded"
                                                @vdropzone-sending-multiple="sendingFiles"
                                                @vdropzone-success-multiple="success"
                                                ><div class="dz-message" data-dz-message><span>Dateien mit Drag & Drop hochladen oder Foto machen</span></div></vue-dropzone>
                                                <AttachmentList
                                                  :tempAttachments="getTempAttachments"
                                                  :attachments="getAttachments"
                                                />
                                            </div>

                                            <div class="form-group">
                                                <label class="form-label" for="infos">Wie und wann können wir Sie für Rückfragen erreichen<span class="text-danger">*</span>:</label>
                                                <textarea name="infos" v-model="formdata.infos" class="form-control" id="infos"></textarea>
                                                <div class="invalid-feedback d-block" v-if="formdata_errors.includes('infos')">
                                                    Bitte geben Sie Infos für evtl. Rückfragen an.
                                                </div>
                                            </div>

                                        </div>

                                    </div>

                                    <div v-show="insuranceData || !kit || jobId">

                                        <div v-if="viewingAppointment">
                                            <div class="bg-soft-warning pt-3 px-4 mb-4">
                                                <p>Sie haben bereits am <strong>{{ viewingAppointment | formatDateTime }}</strong> einen Besichtigungstermin vereinbart.</p>
                                                <p><a href="javascript:void(0)" @click="updateViewingAppointment = true; showConfirmDeleteViewingAppointment = false" tabindex="-1">Besichtigungstermin ändern</a> | <a href="javascript:void(0)" @click="updateViewingAppointment = false; showConfirmDeleteViewingAppointment = true" tabindex="-1">Besichtigungstermin stornieren</a></p>
                                            </div>
                                        </div>

                                        <div v-if="showConfirmDeleteViewingAppointment">
                                            <div class="bg-soft-danger pt-3 px-4 mb-4">
                                                <p>Hiermit stornieren Sie Ihren Buchungstermin am <strong>{{ viewingAppointment | formatDateTime }}</strong>. Fortfahren?</p>
                                                <button class="btn btn-danger mb-4" @click="onDeleteViewingAppointment()">Ja, Termin jetzt stornieren</button>
                                            </div>
                                        </div>

                                        <div v-if="!viewingAppointment || viewingAppointment == '' || updateViewingAppointment">

                                            <div class="select-employee" v-if="employeeSelect">
                                                <p class="mb-0 font-bold">{{ employeeSelectText }}</p>
                                                <Select2 class="mb-2" v-model="selectedEmployeeId" :options="availableEmployees" @change="onSelectedEmployee()" :settings="{ minimumResultsForSearch: 100, placeholder: 'Bitte wählen' }" />
                                            </div>

                                            <div v-if="availableSlots.availableDates && availableSlots.availableDates.length == 0">
                                                <div class="alert alert-danger" role="alert">
                                                  Leider wurden keine passenden Buchungstermine gefunden.<br />Bitte wählen Sie einen anderen Kalender.
                                                </div>
                                                <p class="text-muted"></p>
                                            </div>

                                            <div :class="loading ? 'fadeout' : ''" v-else>

                                                <div class="booking-info-box" role="note">
                                                  <svg class="booking-info-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                                                    <circle cx="12" cy="12" r="10"></circle>
                                                    <line x1="12" y1="16" x2="12" y2="12"></line>
                                                    <line x1="12" y1="8" x2="12.01" y2="8"></line>
                                                  </svg>
                                                  <span>Terminbuchungen sind möglich bis <strong>{{ maxBookingDateFormatted }}</strong></span>
                                                </div>

                                                <div class="form-group">
                                                    <div :class="{ 'trim-cal-last-week': trimCalendarLastWeek }">
                                                      <vc-date-picker v-model="selectedDate" :value="null" :min-date='attributes.min_date' :max-date='attributes.max_date' is-inline is-expanded title-position="left" :available-dates='attributes.available_dates' :disabled-dates='attributes.disabled_dates' :attributes="vcCalendarAttrs" @dayclick='dayClicked' @update:from-page="p => calendarPage = p" ref="datepicker" />
                                                    </div>
                                                </div>

                                                <div v-if="timSlotsloading" class="slot-loading-container">
                                                  <div class="slot-spinner"></div>
                                                </div>

                                                <div v-if="availableSlots.slots && availableSlots.slots.length > 0 && timSlotsloading === false">

                                                    <p>Welche Zeit passt Ihnen am <strong>{{ availableSlots.selectedDate | formatDate }}</strong> am besten?</p>

                                                    <div class="row no-gutters">
                                                        <div class="col-3" v-for="slot in availableSlots.slots" :key="slot.id" @click="onSelectSlot(slot)">
                                                            <div class="booking-slot p-2 mb-2 shadow rounded" v-bind:class="{ active: slotActive(slot.id) }">
                                                            <p class="small m-0 text-center">{{ slot.start | formatTimeSlot }}</p>
                                                            </div>
                                                        </div>
                                                    </div>

                                                </div>

                                                <div v-if="availableSlots.slots && availableSlots.slots.length == 0 && timSlotsloading === false">
                                                    <div class="alert alert-danger" role="alert">
                                                      Leider wurden keine passenden Buchungstermine gefunden.<br />Bitte wählen Sie einen anderen Tag.
                                                    </div>
                                                </div>

                                                <div v-if="content.setting_guestbooking && !kit && !jobId">
                                                  <button class="btn btn-primary my-3 mr-1 float-right" v-if="selectedSlotIds.length" @click="onSlotsSelectedGuest()">Weiter</button> <!-- Deprecated: Gastbuchung Neu -->
                                                </div>
                                                <div v-else>
                                                  <button class="btn btn-primary my-3 mr-1 float-right" v-if="selectedSlotIds.length" @click="onSlotsSelected()">Weiter</button> <!-- Angemeldet oder bestehender Job -->
                                                </div>

                                                <div class="mt-4 text-danger" v-if="insuranceData"><small>* = Erforderlich</small></div>

                                            </div>

                                        </div>

                                    </div>

                                </div>

                                <div v-if="(kit || licenseplateFound) && onlineOffer">

                                    <div v-if="!onlineOfferDocumentsOnly">
                                        <h5>Onlineangebot anfordern</h5>
                                    </div>
                                    <div v-else>
                                        <h5>Bilder und Dokumente hochladen</h5>
                                    </div>

                                    <!-- Onlineangebot anfordern Partner -->
                                    <div v-if="onlineOfferPartnerUrl">
                                        <p class="mb-2">{{ onlineOfferPartnerText }}</p>
                                        <p>Klicken Sie hier um zu unserem Partner zu gelangen (externe Webseite).</p>
                                        <div class="form-row mt-4 d-flex align-items-center">
                                            <div class="form-group col-md-4 licenseplate-tall-wrapper" v-if="!jobId && !selectedJobId">
                                                <label class="form-label">Ihr Kennzeichen<span class="text-danger">*</span>:</label>
                                                <input type="text" name="licenseplate" v-model="formdata_offer.licenseplate" @keyup="formatLicensePlate2($event.target.value)" class="form-control licenseplate-tall">
                                                <p class="small text-muted m-0">NU-KS 123</p>
                                                <div class="invalid-feedback d-block" v-if="formdata_offer_errors.includes('licenseplate')">
                                                    Bitte geben Sie Ihr Kennzeichen an.
                                                </div>
                                            </div>
                                            <div class="col-md-8">
                                                <div v-if="jobId || selectedJobId">
                                                    <a :href="onlineOfferPartnerUrl + '/#/?jobId=' + jobId" class="btn btn-primary my-3 mr-1" target="_blank" >zum Partner <i class="fa fa-arrow-right" aria-hidden="true"></i></a>
                                                </div>
                                                <div v-else>
                                                    <a :href="onlineOfferPartnerUrl + '/#/?numberPlate=' + formdata_offer.licenseplate + '&customerIdentityToken=' + token" class="btn btn-primary my-3 mr-1" target="_blank" >zum Partner <i class="fa fa-arrow-right" aria-hidden="true"></i></a>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div v-else>

                                        <div v-if="!kit">

                                            <div v-if="typeDetails" class="reviewbox relative mb-4">
                                                <h5>Ihr Fahrzeug</h5>
                                                <p class="mb-0">Kennzeichen: <strong>{{ licenseplate }}</strong></p>
                                                <p class="mb-0">
                                                    <span v-if="typeDetails.manufacturer">Hersteller: <strong>{{ typeDetails.manufacturer }}</strong></span><br />
                                                    <span v-if="typeDetails.productionSeries">Modell: <strong>{{ typeDetails.productionSeries }}</strong></span><br />
                                                    <!--<span v-if="typeDetails.vin">VIN / Fahrgestellnummer: <strong>{{ typeDetails.vin }}</strong></span>-->
                                                </p>
                                                <div class="vehicle-img">
                                                    <!--<img src="/images/hyundai.png" class="img-fluid">-->
                                                </div>
                                            </div>

                                        </div>

                                        <div v-else>

                                            <div v-if="onlineOfferDocumentsOnly">
                                                <p class="mt-3">Laden Sie hier Ihre Bilder und Dokumente hoch:</p>
                                            </div>
                                            <div v-else>
                                                <div v-show="!insuranceData && !jobId">
                                                    <!--<p class="mt-3">Um einen neuen Besichtigungstermin zu vereinbaren benötigen wir von Ihnen folgende Angaben:</p>-->
                                                    <!-- START abfrage versicherung -->
                                                    <Insurance @insurance-data-completed="getInsuranceData" :initInsuranceData="initInsuranceData" />
                                                    <!-- END abfrage versicherung -->
                                                </div>

                                                <div v-show="insuranceData">
                                                    <div class="insurance-data" v-if="insuranceData.damagetype">
                                                        <h5>Ihre Angaben zur Versicherung</h5>
                                                        <div v-if="insuranceData.damagetype">Haftpflicht oder Kasko? <strong>{{ insuranceData.damagetype }}</strong></div>
                                                        <div v-if="insuranceData.company">Ihre Versicherung: <strong>{{ insuranceData.company }}</strong></div>
                                                        <div v-if="insuranceData.reported">Schaden gemeldet? <strong>{{ insuranceData.reported }}</strong></div>
                                                        <div v-if="insuranceData.hasdamagenumber">Schadennummer erhalten? <strong>{{ insuranceData.hasdamagenumber }}</strong></div>
                                                        <div v-if="insuranceData.damagenumber">Schadennummer: <strong>{{ insuranceData.damagenumber }}</strong></div>
                                                    </div>

                                                    <div class="form-row" v-bind:class="{ 'active': insuranceData }">
                                                        <div class="col-md-12">
                                                            <p><strong>Bitte ergänzen Sie noch folgende Daten zu Ihrem Fahrzeug:</strong></p>
                                                        </div>
                                                    </div>
                                                </div>

                                                <!--<p class="mt-3">Um ein Onlineangebot anzufordern, benötigen wir von Ihnen folgende Angaben:</p>-->
                                            </div>



                                            <div v-if="!onlineOfferDocumentsOnly && !jobId && insuranceData"> <!-- war: v-if="!onlineOfferDocumentsOnly && !jobId"  -->

                                                <!--<div class="form-row mt-4">

                                                    <div class="form-group col-md-4">
                                                        <label class="form-label">Ihr Kennzeichen<span class="text-danger">*</span>:</label>
                                                        <input type="text" name="licenseplate" v-model="formdata_offer.licenseplate" @keyup="formatLicensePlate2($event.target.value)" class="form-control">
                                                        <p class="small text-muted m-0">NU-KS 123</p>
                                                        <div class="invalid-feedback d-block" v-if="formdata_offer_errors.includes('licenseplate')">
                                                            Bitte geben Sie Ihr Kennzeichen an.
                                                        </div>
                                                    </div>

                                                    <div class="form-group col-md-8">
                                                        <label class="form-label">VIN / Fahrgestellnummer<span class="text-danger">*</span></label>
                                                        <input type="text" name="vin" v-model="formdata_offer.vin" maxlength="17" class="form-control">
                                                        <p class="small text-muted m-0"><a href="https://de.wikipedia.org/wiki/Fahrzeug-Identifizierungsnummer#:~:text=Die%20Fahrzeug%2DIdentifizierungsnummer%20(FIN),und%20weit%20verbreitet%20so%20genannt." target="_blank" tabindex="-1">wo finde ich die?</a></p>
                                                        <div class="invalid-feedback d-block" v-if="formdata_offer_errors.includes('vin')">
                                                            Bitte geben Sie Ihre VIN / Fahrgestellnummer an.
                                                        </div>
                                                    </div>

                                                </div>

                                                <div class="form-row">

                                                    <div class="form-group col-md-4">
                                                        <label class="form-label">Hersteller<span class="text-danger">*</span>:</label>
                                                        <input type="text" name="brand" v-model="formdata_offer.brand" class="form-control">
                                                        <p class="small text-muted m-0">Ford</p>
                                                        <div class="invalid-feedback d-block" v-if="formdata_offer_errors.includes('brand')">
                                                            Bitte geben Sie einen Hersteller an.
                                                        </div>
                                                    </div>

                                                    <div class="form-group col-md-4">
                                                        <label class="form-label">Modell<span class="text-danger">*</span>:</label>
                                                        <input type="text" name="model" v-model="formdata_offer.model" class="form-control">
                                                        <p class="small text-muted m-0">Focus</p>
                                                        <div class="invalid-feedback d-block" v-if="formdata_offer_errors.includes('model')">
                                                            Bitte geben Sie ein Modell an.
                                                        </div>
                                                    </div>

                                                    <div class="form-group col-md-4">
                                                        <label class="form-label">Erstzulassung:</label>
                                                        <input type="date" name="ez" v-model="formdata_offer.ez" class="form-control">
                                                        <p class="small text-muted m-0">z.B. 01.04.2000</p>
                                                    </div>

                                                </div>

                                                -->

                                                <KSRSelectVehicle @setvehicle="setVehicle" :kit="kit" />
                                                <div class="invalid-feedback d-block invalid-vehicle" v-if="formdata_offer_errors.includes('licenseplate')">
                                                Bitte wählen Sie ein Fahrzeug aus.
                                                </div>


                                            </div>

                                            <div v-if="jobId" class="reviewbox relative mb-4">
                                                <h5>Ihr Fahrzeug</h5>
                                                <p>Kennzeichen: <strong>{{ jobData.value.vehicle.registrationDetails.registrationPlate }}</strong></p>
                                                <p>Hersteller: <strong>{{ jobData.value.vehicle.typeDetails.manufacturer }}</strong><br />
                                                <!--VIN / Fahrgestellnummer: <strong>{{ jobData.value.vehicle.typeDetails.vin }}</strong><br />-->
                                                Modell: <strong>{{ jobData.value.vehicle.typeDetails.productionSeries }}</strong></p>
                                                <div class="vehicle-img">
                                                    <!--<img src="/images/hyundai.png" class="img-fluid">-->
                                                </div>
                                            </div>

                                        </div>

                                        <div v-show="!kit || (kit && insuranceData) || jobId">

                                            <div class="form-row" v-if="!onlineOfferDocumentsOnly">

                                                <div class="form-group col-md-12">
                                                    <div :class="['', (formdata_offer_errors.includes('registration') ? 'invalid-registration' : ''), (formdata_offer_errors.includes('damageId') ? 'invalid-damage' : '')]">
                                                        <KSRUploadDocuments :kit="kit" :damageToken="damageToken" :storeId="studioId" :jobId="jobId" :embedded="true" :content="content" ref="uploadDocumentsChild" @damageWindowOpen="isDamageWindowOpen" :parent_formerrors="formdata_offer_errors" />
                                                        <!--<KSRDamageRecording :kit="kit" :storeId="studioId" :hideTitle="true" @setdamage="setDamage" :required="true" singleUpload="true" />
                                                        <div class="invalid-feedback d-block invalid-vehicle" v-if="formdata_offer_errors.includes('damageId')">
                                                        Bitte wählen Sie einen Schaden aus.
                                                        </div>-->
                                                        <div class="invalid-feedback d-block" v-if="formdata_offer_errors.includes('registration')">
                                                            Sie haben noch keinen Fahrzeugschein erfasst.
                                                        </div>
                                                    </div>
                                                </div>

                                                <div class="form-group col-md-12"> <!-- wieder eingeblendet 12/24 -->
                                                    <label class="form-label" for="description">Schadenbeschreibung<span class="text-danger" v-if="!kit || (kit && !jobId)">*</span>:</label>
                                                    <textarea name="description" id="description" v-model="formdata_offer.description" class="form-control"></textarea>
                                                    <p class="small text-muted" v-if="!formdata_offer_errors.includes('description')">Bitte geben Sie hier eine möglichst präzise Beschreibung Ihres Schadens an.</p>
                                                    <div class="invalid-feedback d-block" v-if="formdata_offer_errors.includes('description')">
                                                        Bitte geben Sie hier eine möglichst präzise Beschreibung Ihres Schadens an.
                                                    </div>
                                                </div>

                                            </div>

                                            <div class="form-row">

                                                <div class="form-group col-md-12" v-if="!onlineOfferDocumentsOnly">
                                                    <label class="form-label" for="infos">Wie und wann können wir Sie für Rückfragen erreichen<span class="text-danger" v-if="!kit || (kit && !jobId)">*</span>:</label>
                                                    <textarea name="infos" id="infos" v-model="formdata_offer.infos" class="form-control"></textarea>
                                                    <div class="invalid-feedback d-block" v-if="formdata_offer_errors.includes('infos')">
                                                        Bitte geben Sie Infos für evtl. Rückfragen an.
                                                    </div>
                                                </div>

                                                <div class="form-group col-md-12" v-if="!onlineOfferDocumentsOnly">
                                                    <label class="form-label">Ich wünsche</label>

                                                    <div class="form-check">
                                                      <input class="form-check-input" v-model="formdata_offer.offerviaemail" type="checkbox" id="offerviaemail">
                                                      <label class="form-check-label" for="offerviaemail">
                                                        ein Angebot per E-Mail
                                                      </label>
                                                    </div>
                                                    <div class="form-check">
                                                      <input class="form-check-input" v-model="formdata_offer.appointment" type="checkbox" id="appointment">
                                                      <label class="form-check-label" for="appointment">
                                                        einen möglichen Reparaturtermin
                                                      </label>
                                                    </div>
                                                    <div class="form-check">
                                                      <input class="form-check-input" v-model="formdata_offer.replacementvehicle" type="checkbox" id="replacementvehicle">
                                                      <label class="form-check-label" for="replacementvehicle">
                                                        Ich benötige einen Ersatzwagen während der Reparatur
                                                      </label>
                                                    </div>

                                                </div>

                                            </div>

                                            <!-- Nicht angemeldet / Onlineangebot anfordern für bestehenden Job -->
                                            <div v-if="!kit && !onlineOfferDocumentsOnly && jobId">
                                                <button class="btn btn-primary my-3 mr-1 float-right" v-if="" @click="onRequestOffer()" :disabled="loading">
                                                <div class="spinner-border text-white mr-2" role="status" v-if="loading">
                                                    <span class="sr-only">Loading...</span>
                                                </div>
                                                Onlineangebot anfordern</button>
                                            </div>

                                            <!-- Angemeldet / Onlineangebot anfordern für neuen Job -->
                                            <div v-if="kit && !onlineOfferDocumentsOnly && !jobId">
                                                <button class="btn btn-primary my-3 mr-1 float-right" v-if="" @click="onRequestOffer()" :disabled="loading || hideSubmitButtonOnlineOffer">
                                                <div class="spinner-border text-white mr-2" role="status" v-if="loading">
                                                    <span class="sr-only">Loading...</span>
                                                </div>
                                                Onlineangebot anfordern</button>
                                            </div>

                                            <!-- Angemeldet / Onlineangebot anfordern für bestehenden Job -->
                                            <div v-if="kit && !onlineOfferDocumentsOnly && jobId">
                                                <button class="btn btn-primary my-3 mr-1 float-right" v-if="" @click="onUpdateJob()" :disabled="loading">
                                                <div class="spinner-border text-white mr-2" role="status" v-if="loading">
                                                    <span class="sr-only">Loading...</span>
                                                </div>
                                                Onlineangebot anfordern</button>
                                            </div>


                                            <!-- Angemeldet oder per Direktlink / Onlineangebot nur Dokumente und Bilder hochladen -->
                                            <!--<div v-if="onlineOfferDocumentsOnly && jobId">
                                                <button class="btn btn-primary my-3 mr-1 float-right" v-if="" @click="onUploadDocuments()" :disabled="loading">
                                                <div class="spinner-border text-white mr-2" role="status" v-if="loading">
                                                    <span class="sr-only">Loading...</span>
                                                </div>
                                                Dokumente an Werkstatt übertragen</button>
                                            </div>-->

                                            <div v-if="kit && !onlineOfferDocumentsOnly && jobId"></div>
                                            <div v-else class="mt-4 text-danger"><small>* = Erforderlich</small></div>

                                        </div>

                                    </div>

                                </div>

                            </div> <!-- /.slide -->

                            <div class="slide">

                                <h5>Ihre Buchung:</h5>

                                <div v-if="!viewing_appointment">

                                    <div v-if="selectedSlots.length > 0" class="reviewbox">
                                        <div v-if="kit && licenseplate == 'k'">
                                            <p v-if="formdata.licenseplate || formdata.ez || formdata.brand || formdata.model">
                                                <span v-if="formdata.licenseplate"><strong>Kennzeichen:</strong> {{ formdata.licenseplate }}</span><br />
                                                <span v-if="formdata.ez"><strong>Erstzulassung:</strong> {{ formdata.ez | formatDate }}</span><br />
                                                <span v-if="formdata.brand"><strong>Hersteller:</strong> {{ formdata.brand }}</span><br />
                                                <span v-if="formdata.model"><strong>Modell:</strong> {{ formdata.model }}</span><br />
                                                <span v-if="formdata.vin"><strong>VIN / Fahrgestellnummer:</strong> {{ formdata.vin }}</span>
                                            </p>
                                            <!--<p v-if="formdata.vehicleId">
                                                <strong>Ausgewähltes Fahrzeug:</strong><br />
                                                {{ getVehicleById(formdata.vehicleId) }}
                                            </p>-->
                                            <!--<p><strong>Schadenbeschreibung3:</strong><br />
                                            {{ formdata.description }}</p>-->
                                            <p><strong>Wie und wann können wir Sie für Rückfragen erreichen:</strong><br />
                                            {{ formdata.infos }}</p>
                                            </p>
                                        </div>
                                        <div v-else>
                                            <p v-if="licenseplate && licenseplate != '0'">Kennzeichen: <strong>{{ licenseplate }}</strong></p>
                                            <div v-if="typeDetails.manufacturer || typeDetails.model" class="mb-2">
                                                <p>Hersteller: <strong>{{ typeDetails.manufacturer }}</strong><br />
                                                Modell: <strong>{{ typeDetails.model }}</strong></p>
                                            </div>
                                            <h5>Ihre Buchung</h5>
                                            <p class="mb-0">Datum/Uhrzeit: {{ selectedSlots[0].start | formatDateTime }}</p>
                                            <p>{{ employeeSelectedText }}: {{ selectedEmployee }} </p>
                                            <div class="vehicle-img">
                                                <!--<img src="/images/hyundai.png" class="img-fluid">-->
                                            </div>
                                        </div>
                                    </div>

                                    <div v-if="kit && licenseplate == 'k'">
                                        <button class="btn btn-primary my-3 mr-1" v-if="selectedSlotIds.length" @click="onBookNowKit()" :disabled="loading">
                                        <div class="spinner-border text-white mr-2" role="status" v-if="loading">
                                            <span class="sr-only">Loading...</span>
                                        </div>
                                        Jetzt buchen
                                    </button>
                                    </div>
                                    <div v-else>
                                        <button class="btn btn-primary my-3 mr-1" v-if="selectedSlotIds.length" @click="onBookNow()" :disabled="loading">
                                        <div class="spinner-border text-white mr-2" role="status" v-if="loading">
                                            <span class="sr-only">Loading...</span>
                                        </div>
                                        Jetzt Besichtigungstermin buchen
                                        </button>
                                    </div>

                                </div>

                            </div> <!-- /.slide -->

                            <div class="slide">

                                <h2 class="mb-4">{{ last_slide_title }}</h2>
                                <p class="mb-4">{{ last_slide_text }}</p>
                                <div class="mb-1" tabindex="-1">
                                    <a href="javascript:void(0)" @click="reload()" tabindex="-1">Zurück zur Übersicht</a>
                                </div>
                                <div v-if="kit">
                                    <a href="javascript:void(0)" @click="logout()" tabindex="-1">Abmelden</a>
                                </div>

                            </div> <!-- /.slide -->

                        </VueSlickCarousel>

                        <div class="editAccount" v-if="editAccount">

                            <h4>Mein Profil</h4>
                            <div class="bg-soft-danger p-3 mb-4" v-if="accountStatus == 10">
                                Werkstatt-Status: Werkstatt-Konto nicht vorhanden.<br />
                                <!-- user content -->
                                <div v-if="content.profile_noaccount" class="c1" v-html="content.profile_noaccount"></div>
                            </div>
                            <div class="mb-4">
                                <div v-if="accountInfoFull.linkState == 1">
                                    <div class="mb-2">
                                        <span class="badge badge-secondary">Werkstatt-Konto nicht verknüpft</span>
                                    </div>
                                    <!-- user content -->
                                    <div v-if="content.profile_accountnotlinked" class="c2" v-html="content.profile_accountnotlinked"></div>
                                </div>
                                <div v-if="accountInfoFull.linkState == 2">
                                    <div class="mb-2">
                                        <span class="badge badge-success"><i class="fa fa-check-square-o" aria-hidden="true"></i> Werkstatt-Konto verknüpft</span>
                                    </div>
                                    <!-- user content -->
                                    <div v-if="content.profile_accountlinked" class="c2" v-html="content.profile_accountlinked"></div>
                                </div>
                            </div>

                            <form @submit.prevent="onAccount()">

                                <div class="form-row mb-2">

                                    <div class="form-group col-sm-6">
                                        <label for="Salutation">Anrede</label>
                                        <select v-model="accountInfo.salutation" class="form-control" id="Salutation" name="Salutation">
                                            <option value="Frau">Frau</option>
                                            <option value="Herr">Herr</option>
                                        </select>
                                    </div>

                                    <div class="form-group col-sm-6">
                                        <label for="Lastname">Nachname<span class="text-danger">*</span></label>
                                        <input class="form-control" v-model="accountInfo.lastName" placeholder="Nachname" type="text" data-val="true" id="Lastname" name="Lastname" />
                                        <div class="invalid-feedback d-block" v-if="formdata_errors_account.includes('lastName')">
                                            Bitte geben Sie Ihren Nachnamen an.
                                        </div>
                                    </div>


                                    <div class="form-group col-sm-6">
                                        <label for="Firstname">Vorname<span class="text-danger">*</span></label>
                                        <input class="form-control" v-model="accountInfo.firstName" placeholder="Vorname" type="text" id="Firstname" name="Firstname" value="" />
                                        <div class="invalid-feedback d-block" v-if="formdata_errors_account.includes('firstName')">
                                            Bitte geben Sie Ihren Vornamen an.
                                        </div>
                                    </div>

                                    <div class="form-group col-sm-6">
                                        <label for="AdditionalText">Zusatztext</label>
                                        <input class="form-control" v-model="accountInfo.additionalText" placeholder="Zusatztext" type="text" id="AdditionalText" name="AdditionalText" value="" />
                                    </div>

                                    <div class="form-group col-sm-6">
                                        <label for="Street">Straße<span class="text-danger">*</span></label>
                                        <input class="form-control" v-model="accountInfo.street" placeholder="Straße" type="text" id="Street" name="Street" value="" />
                                        <div class="invalid-feedback d-block" v-if="formdata_errors_account.includes('street')">
                                            Bitte geben Sie Ihre Straße an.
                                        </div>
                                    </div>

                                    <div class="form-group col-sm-6">
                                        <label for="ZipCode">PLZ<span class="text-danger">*</span></label>
                                        <input class="form-control" v-model="accountInfo.zipCode" placeholder="Postleitzahl" type="text" id="ZipCode" name="ZipCode" value="" />
                                        <div class="invalid-feedback d-block" v-if="formdata_errors_account.includes('zipCode')">
                                            Bitte geben Sie Ihre PLZ an.
                                        </div>
                                    </div>

                                    <div class="form-group col-sm-6">
                                        <label for="Town">Ort<span class="text-danger">*</span></label>
                                        <input class="form-control" v-model="accountInfo.city" placeholder="Ort" type="text" id="Town" name="Town" value="" />
                                        <div class="invalid-feedback d-block" v-if="formdata_errors_account.includes('city')">
                                            Bitte geben Sie Ihren Ort an.
                                        </div>
                                    </div>

                                    <div class="form-group col-sm-6">
                                        <label for="PhoneMobile">Telefon mobil</label>
                                        <input class="form-control" v-model="accountInfo.mobilePhone" placeholder="Telefon mobil" type="text" id="PhoneMobile" name="PhoneMobile" value="">
                                    </div>

                                </div>

                                <button v-if="accountStatus == 10" class="btn btn-primary" name="button" value="createaccount" @click="onCreateAccount()" :disabled="loading">
                                    <div class="spinner-border text-white mr-2" role="status" v-if="loading">
                                        <span class="sr-only">Loading...</span>
                                    </div>
                                    Werkstatt-Konto erstellen
                                </button>

                                <button v-else class="btn btn-primary" name="button" value="createaccount" @click="onUpdateAccount()" :disabled="loading">
                                    <div class="spinner-border text-white mr-2" role="status" v-if="loading">
                                        <span class="sr-only">Loading...</span>
                                    </div>
                                    Werkstatt-Konto speichern
                                </button>

                                <button class="btn" name="button" @click="onCancelAccount()">
                                    Abbrechen
                                </button>

                                <div class="bg-soft-danger p-3 mt-4" v-if="formdata_errors_account.includes('api')">
                                    Es gab einen Fehler bei der Übermittlung der Daten. Bitte <a href="mailto:support@booklyn.io">kontaktieren</a> Sie uns.
                                </div>

                                <div class="mt-4 text-danger"><small>* = Erforderlich</small></div>

                            </form>

                        </div> <!-- /.slide -->

                    </div> <!-- /.rootsection -->

                </div> <!-- /.col-sm-12 -->

            </div> <!-- /.row -->

            <div class="ksr-booking--footer-links d-flex justify-content-between align-items-center mt-4" v-if="kit">

                <div>
                    <div class="d-sm-flex justify-content-start">
                        <!-- Meine Fahrzeuge -->
                        <a class="primary-link d-flex align-items-center mr-2" href="javascript:void(0)" @click="rootSection = 'vehicles', currentPage = ''" :class="{ active: rootSection == 'vehicles' }">
                            <svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg" class="svg-icon">
                                <g clip-path="url(#clip0_11_43)">
                                <path d="M1.75 10L5.75 6H14.25L17.25 10L22.75 11.3333V16H1.75V10Z" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                <path d="M1.75 10L16.75 10" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                <path d="M9.75 16L9.75 6" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                <path d="M17.75 16L16.75 10" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                <path d="M8.25 16.6899C8.25 18.0707 7.13071 19.1899 5.75 19.1899C4.36929 19.1899 3.25 18.0707 3.25 16.6899" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                <path d="M21.25 16.6899C21.25 18.0707 20.1307 19.1899 18.75 19.1899C17.3693 19.1899 16.25 18.0707 16.25 16.6899" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                </g>
                                <defs>
                                <clipPath id="clip0_11_43">
                                <rect width="24" height="24" fill="white" transform="translate(0.25 0.189941)"/>
                                </clipPath>
                                </defs>
                            </svg>
                            <span class="ml-2">Meine Fahrzeuge</span>
                        </a>
                    </div>
                </div>

                <div>
                    <a lass="primary-link d-flex align-items-center" href="javascript:void(0)" @click="logout()">
                        <span>Abmelden</span>
                        <svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg" class="svg-icon">
                            <path d="M12.75 22.3799C18.2728 22.3799 22.75 17.9027 22.75 12.3799C22.75 6.85704 18.2728 2.37988 12.75 2.37988C7.22715 2.37988 2.75 6.85704 2.75 12.3799C2.75 17.9027 7.22715 22.3799 12.75 22.3799Z" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                            <path d="M15.75 9.37988L9.75 15.3799" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                            <path d="M9.75 9.37988L15.75 15.3799" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>
                    </a>
                </div>

            </div>

        </div>

    </div> <!-- /.ksr-booking -->

</template>

<script>

    import { onMounted, nextTick } from "vue";
    import VueSlickCarousel from 'vue-slick-carousel';
    import 'vue-slick-carousel/dist/vue-slick-carousel-theme.css';
    import vue2Dropzone from 'vue2-dropzone';
    import 'vue2-dropzone/dist/vue2Dropzone.min.css';
    import AttachmentList from "./AttachmentList";
    import Insurance from "./Insurance";
    import KSRMechanik from "./KSRMechanik";
    import KSRSingleJob from "./KSRSingleJob";
    import KSRVehicles from "./KSRVehicles";
    import KSRSelectVehicle from "./KSRSelectVehicle";
    import KSRDamageRecording from "./KSRDamageRecording";
    import KSRUploadDocuments from "./KSRUploadDocuments";
    import KSRMessageToBodyshop from "./KSRMessageToBodyshop";

    export default {

        components: { VueSlickCarousel, vueDropzone: vue2Dropzone, AttachmentList: AttachmentList, Insurance: Insurance, KSRMechanik: KSRMechanik, KSRSingleJob: KSRSingleJob, KSRVehicles: KSRVehicles, KSRSelectVehicle, KSRDamageRecording, KSRUploadDocuments, KSRMessageToBodyshop },

    	data() {
            return {
                rootSection: 'kl',
                services: [],
                servicesArr: [],
                selectedService: '',
                availableSlots: false,
                allSlots: [],
                selectedSlot: '', // old, TODO check ob noch gebraucht
                selectedSlots: [], // new 06/2021
                selectedSlotIds: [], // new 06/2021
                formdata: { first_name: '', last_name: '', address: '', zip: '', city: '', phone: '', email: '', comment:'', licenseplate:'', vin:'', brand:'', model: '', ez: '', description: '', infos: '', vehicleId: '', damageId: '' },
                formdata_errors: [],
                //formmeta: { pax: '1' },
                //formdata_viewing: { licenseplate: '', brand: '', model: '', ez: '', description: '', infos: '' },
                formdata_offer: { licenseplate:'', vin:'', brand:'', model: '', ez: '', description: '', infos: '', appointment: false, offerviaemail: false, replacementvehicle: false, vehicleId: '', damageId: '' },
                formdata_offer_errors: [],
                selectedHaendler: [],
                formerrors: {},
                selectedDate: '',
                suggestions: '',
                allTimeSlots: '',
                selectedCalendar: '',
                selectedTimeSlot: {},
                step: 1,
                attributes:
                    {
                        min_date: '',
                        max_date: '',
                        disabled_dates: {},
                        //disabled_dates: { weekdays: [1] },
                        available_dates: [],
                    },
                rangeAnchor: null,
                min_date_range: '',
                max_date_range: '',
                calendarPage: null,
                firstBookableSlot: null,
                timSlotsloading: false,
                slicksettings: {
                  arrows: false,
                  dots: false,
                  infinite: false,
                  slidesToShow: 1,
                  slidesToScroll: 1,
                  draggable: false,
                  initialSlide: 0,
                  swipe: false
                },
                comment_placeholder: "" ,
                loading: false,
                error: false,
                licenseplate: '',
                typeDetails: '',
                current_employee_id: '',
                availableEmployees: [],
                selectedEmployeeId: '',
                selectedEmployee: '',
                selectedJobId: '',
                selectedCompanyId: '',
                licenseplateFound: false,
                licenseplateValid: false,
                employeeSelect: '',
                employeeSelectText: '',
                employeeSelectedText: '',
                sms: false,
                viewing_appointment: false,
                brands: [],
                models: [],
                modelsloading: false,
                brandLogoUrl: '',
                errors_viewing: [],
                progress: false,
                progressInfo: false,
                onlineOffer: false,
                onlineOfferPartnerUrl: false,
                onlineOfferPartnerText: false,
                onlineOfferDocumentsOnly: false,
                tempAttachments: [],
                attachments: [],
                filesAdded: [],
                tempAttachments2: [],
                attachments2: [],
                filesAdded2: [],
                dropzoneOptions: {
                    url: 'https://booklyn.io/',
                    //autoProcessQueue: false,
                    maxFilesize: 10000000,
                    headers: {
                        //Authorization: ``
                    },
                    paramName: function(n) {
                        return "file[]";
                    },
                    dictDefaultMessage: "Dateien hier ablegen",
                    includeStyling: false,
                    previewsContainer: false,
                    thumbnailWidth: 250,
                    thumbnailHeight: 140,
                    uploadMultiple: true,
                    parallelUploads: 5,
                    createImageThumbnails: true,
                    maxThumbnailFilesize: 10,
                    acceptedFiles: 'image/*,application/pdf', // needed for IOS/Android to show both camera and filebrowser
                    init: function() {
                      // Still enforce image-only validation
                      this.on("addedfile", function(file) {
                        if (!file.type.match(/^image\//)) {
                          this.removeFile(file);
                          alert("Nur Bilddateien sind erlaubt!");
                        }
                      });
                    }
                },
                requestId: '',
                viewingAppointment: '',
                updateViewingAppointment: false,
                showConfirmDeleteViewingAppointment: false,
                last_slide_title: 'Vielen Dank für Ihre Buchung!',
                last_slide_text: '',
                kit: '',
                token: '',
                accountStatus: 0,
                editAccount: false,
                accountInfo: { salutation: 'Herr', firstName: '', lastName: '', additionalText: '', mobilePhone: '', eMail: '', street: '', zipCode: '', city: '' },
                accountInfoFull: false,
                accountInfoJobs: false,
                accountInfoVehicles: false,
                formdata_errors_account: [],
                kitShowLicensePlateInput: false,
                currentPage: false,
                jobId: '',
                jobData: {},
                insuranceData: false,
              initInsuranceData: 1,
                content: {},
                service_reload: 0,
                hideFirstPage: false,
                singleTokenActive: false,
                //clientVehicles: [],
                //clientVehicleId: '',
                //addNewVehicle: false,
                //editVehicle: false,
                hideSlick: false,
                jobIdLoading: false,
                damageToken: false,
                thirdPartyCookiesSupported: false,
                storeUrl: window.location.href.replace("/embed", ''),
                identityToken: '',
                bodyshopMessage: '',
                hideSubmitButtonOnlineOffer: false,
                shouldForceService: false,
                loadingEmployeeCalender: false
            };
        },

        created() {
          // Check for identityToken in regular query params first, then in route query params
          const identityToken = this.getIdentityTokenFromUrl();

          if (identityToken) {
            this.setIdentityToken(identityToken);
            this.removeIdentityTokenFromUrl();
          } else {
            // Fallback to session storage
            this.identityToken = sessionStorage.getItem('identityToken');
          }
          
          // replace vue router links for the store url
          this.storeUrl = this.storeUrl.split('#')[0];

          // Remove everything behind the ? in the storeUrl if there is a question mark in the URL
          if (this.storeUrl.includes('?')) {
            this.storeUrl = this.storeUrl.split('?')[0];
          }

          //embed Check if the current window location includes '' and add it to the storeUrl with '/embed'
          if (window.location.href.includes('embed')) {
            this.storeUrl += '/embed';
          }
          if (window.location.href.includes('modal')) {
            this.storeUrl += '?modal=1';
          }
          

        },

        watch: {
          '$route': {
            handler(to) {
              if (this.shouldForceService && !this.kit && (to.path === '/' || to.path === '/buchen') && this.$route.path === '/') {
                this.$router.replace('/service');
              }
            },
            immediate: true
          }
        },

        mounted() {

            //this.rootSection = 'dokdebug';

            const tomorrow = new Date();
            tomorrow.setDate(tomorrow.getDate() + 1);
            this.attributes.min_date = tomorrow;

            var _this = this;

            // check hash
            if(window.location.hash && window.location.hash == '#service') {
                this.rootSection = 'mechanik';
            }

            // check for booklyn token to view job directly
            const queryString = window.location.search;
            const urlParams = new URLSearchParams(queryString);
            const booklyn_token = urlParams.get('t')
            if(booklyn_token) {
                this.rootSection = 'singlejob';
                this.singleTokenActive = true;
            }

            // get content
            console.log("get content");
            let url = '/api/ksr/'+this.studioId+'/content';
            axios.get(url)
            .catch(function (error) {
                //console.log(error);
            })
            .then((response) => {
                if(response.data.setting_kl == 0 && response.data.setting_service == 1) {
                  if(response.data.setting_guestbooking !== 1) {
                    _this.rootSection = 'mechanik';
                  }
                  else {
                    // redirect to guest service
                    //console.log('trying to redirect to service');
                    //console.log(_this.$route.path);
                    if(_this.$route.path === '/' || _this.$route.path === '/buchen') {
                      //console.log('redirect to service');
                      _this.$router.push('/service');
                      _this.shouldForceService = true;
                    }
                  }
                }
                _this.content = response.data;
            });

            // Check if user is logged in
            //var kit = this.$cookies.get("kit");
            let kit = this.identityToken;
            if(kit) {

                this.loading = true;
                this.kit = kit;

                // Check User Status
                let url = '/api/ksr/'+this.studioId+'/userstatus?identityToken='+this.identityToken;
                axios.get(url)
                .catch(function (error) {
                    // empty catch
                    //console.log(error);
                })
                .then((response) => {
                    //_this.accountStatus = response.data.status;
                    //if(response.data.status == 10) {
                    if(response.data.info.value == null) {
                        // Kunde hat noch kein Werkstattkonto
                        _this.accountStatus = 10;
                        _this.onEditAccount();
                        //_this.accountInfo.eMail = response.data.info.value.email;
                    }
                    else {
                        // Kunde hat Werkstatt-Konto
                        //console.log(response.data.info);
                        var customerIdentity = response.data.info.value.customerIdentity;
                        _this.accountInfo.salutation = customerIdentity.salutation;
                        _this.accountInfo.firstName = customerIdentity.firstName;
                        _this.accountInfo.lastName = customerIdentity.lastName;
                        _this.accountInfo.additionalText = customerIdentity.additionalText;
                        _this.accountInfo.mobilePhone = customerIdentity.contactInformation.mobilePhone;
                        _this.accountInfo.eMail = customerIdentity.contactInformation.eMail;
                        _this.accountInfo.street = customerIdentity.postalAddress.street;
                        _this.accountInfo.zipCode = customerIdentity.postalAddress.zipCode;
                        _this.accountInfo.city = customerIdentity.postalAddress.city;

                        _this.accountInfoFull = response.data.info.value;
                        _this.accountInfoJobs = response.data.jobs;
                        _this.accountInfoVehicles = response.data.vehicles;
                        _this.token = response.data.token;

                        if(this.rootSection != 'singlejob') {
                            _this.onLicensePlateInput();
                        }
                    }
                    this.loading = false;
                });

            }

            // check for third party cookies
            var receiveMessage = function (evt) {
                if (evt.data === 'MM:3PCunsupported') {
                    document.getElementById('result').innerHTML = 'not supported';
                    _this.thirdPartyCookiesSupported = false;
                } else if (evt.data === 'MM:3PCsupported') {
                    document.getElementById('result').innerHTML = 'supported';
                    _this.thirdPartyCookiesSupported = true;
                }
            };
            window.addEventListener("message", receiveMessage, false);

            // Accessibility check for slick slide children (@ms, added 2025-02-10)
            // Wait until VueSlickCarousel renders
            this.$nextTick(() => {
                this.observeSlides();
            });
        },

        computed: {
            maxBookingDateFormatted() {
                const days = this.content.setting_maxdays_viewing || 30;
                const date = moment().add(days, 'days');
                const weekday = date.toDate().toLocaleDateString('de-DE', { weekday: 'long' });
                return `${weekday}, ${date.format('D.M.YYYY')}`;
            },
            trimCalendarLastWeek() {
                const page = this.calendarPage;
                let year, month;
                if (page) {
                    year = page.year; month = page.month;
                } else if (this.selectedDate) {
                    const d = new Date(this.selectedDate);
                    year = d.getFullYear(); month = d.getMonth() + 1;
                } else {
                    return false;
                }
                const firstDayMon = (new Date(year, month - 1, 1).getDay() + 6) % 7;
                const daysInMonth = new Date(year, month, 0).getDate();
                return firstDayMon + daysInMonth <= 35;
            },
            vcCalendarAttrs() {
                if (!this.rangeAnchor) return [];

                const rangeStart = new Date(this.rangeAnchor);
                rangeStart.setHours(0, 0, 0, 0);
                const rangeEnd = new Date(this.rangeAnchor);
                rangeEnd.setDate(rangeEnd.getDate() + 30);
                rangeEnd.setHours(23, 59, 59, 999);

                if (this.attributes.max_date) {
                    const maxEnd = new Date(this.attributes.max_date);
                    maxEnd.setHours(23, 59, 59, 999);
                    if (maxEnd < rangeEnd) {
                        rangeEnd.setTime(maxEnd.getTime());
                    }
                }

                const beforeMin = new Date(this.attributes.min_date);
                beforeMin.setHours(0, 0, 0, 0);

                const availableSet = new Set(
                    (this.attributes.available_dates || []).map(d => moment(d).format('YYYY-MM-DD'))
                );
                const unavailableDates = [];
                const cursor = new Date(rangeStart);
                while (cursor <= rangeEnd) {
                    if (!availableSet.has(moment(cursor).format('YYYY-MM-DD'))) {
                        unavailableDates.push(new Date(cursor));
                    }
                    cursor.setDate(cursor.getDate() + 1);
                }

                const attrs = [
                    {
                        key: 'unavailable-in-range',
                        highlight: { class: 'vc-unavail-hl', contentClass: 'vc-unavailable' },
                        dates: unavailableDates
                    },
                    {
                        key: 'booking-range',
                        highlight: {
                            class: 'vc-booking-range-hl',
                            contentClass: 'vc-booking-range-content',
                            backgroundColor: '#e8f0fe',
                            borderWidth: '0',
                            borderRadius: '0'
                        },
                        dates: { start: rangeStart, end: rangeEnd }
                    },
                    {
                        key: 'before-min',
                        highlight: { class: 'vc-oor-hl', contentClass: 'vc-oor' },
                        dates: { start: null, end: beforeMin }
                    }
                ];

                if (this.attributes.max_date) {
                    const afterMax = new Date(this.attributes.max_date);
                    afterMax.setDate(afterMax.getDate() + 1);
                    afterMax.setHours(0, 0, 0, 0);
                    attrs.push({
                        key: 'after-max',
                        highlight: { class: 'vc-oor-hl', contentClass: 'vc-oor' },
                        dates: { start: afterMax, end: null }
                    });
                }

                return attrs;
            },
            getTempAttachments() {
                return this.tempAttachments;
            },
            getAttachments() {
                return this.attachments;
            },
            getTempAttachments2() {
                return this.tempAttachments2;
            },
            getAttachments2() {
                return this.attachments2;
            }
        },

        methods: {

            formatLicensePlate () {

                if(!this.licenseplate.includes('-'))
                    this.licenseplate = this.licenseplate.replace(/ /g,'-');

                this.licenseplate = this.licenseplate.toUpperCase();

                if(this.licenseplate.length > 5)
                    this.licenseplateValid = true;
                else
                    this.licenseplateValid = false;
                //this.licenseplate = this.licenseplate.replace(/[0-9]/g, '')
            },

            formatLicensePlate2 (licenseplate) {
                if(!licenseplate.includes('-'))
                    licenseplate = licenseplate.replace(/ /g,'-');
                licenseplate = licenseplate.toUpperCase();
                this.formdata_offer.licenseplate = licenseplate;
                this.formdata.licenseplate = licenseplate;
            },

            onKitToggleLicensePlateInput() {
                if(!this.kitShowLicensePlateInput) {
                    this.licenseplate = '';
                    this.licenseplateFound = false;
                    this.kitShowLicensePlateInput = true;
                }
                else {
                    this.licenseplate = 'k';
                    this.licenseplateFound = true;
                    this.kitShowLicensePlateInput = false;
                }
            },

            //onContinueWithoutLicenseplate() {
            //    this.error = 'Bitte treffen Sie eine Auswahl:';
            //},

          onLicensePlateInput: function (refresh, jobId) {

            //console.log("job id: " + jobId);
            //console.log(this.licenseplate);

            this.licenseplateFound = false; // reset
            this.hideSlick = false;

            var refresh = refresh || false;
            var jobId = jobId || false;
            this.error = false;
            this.loading = true;
            var _this = this;

            this.damageToken = false;

            const tomorrow = new Date();
            tomorrow.setDate(tomorrow.getDate() + 1);
            let tomorrowStr = moment(String(tomorrow)).format('YYYY-MM-DD');

            if (this.kit && !this.kitShowLicensePlateInput && !jobId) {
              this.licenseplate = 'k';
            }

            //console.log(this.licenseplate);

            let licenseplate = encodeURIComponent(this.licenseplate);
            let url = '/api/ksr/' + this.studioId + '/' + licenseplate + '/get-slots/?date=' + tomorrowStr;
            if (refresh) {
              url = '/api/ksr/' + this.studioId + '/' + licenseplate + '/get-slots/?date=' + tomorrowStr + '&employeeId=' + this.selectedEmployeeId;
            }

            if (jobId) {
              url += '&jobId=' + jobId;
            }

            if (this.firstBookableSlot) url += '&firstBookableSlot=' + encodeURIComponent(this.firstBookableSlot);
            url += '&identityToken=' + this.identityToken;

            axios.get(url)
                .catch(function (error) {
                  // empty catch
                })
                .then((response) => {
                  //console.log(response);
                  if (!response) {
                    _this.error = 'Wir haben keinen laufenden Auftrag zu diesem Kennzeichen gefunden.';
                    _this.loading = false;
                    // scroll down
                    setTimeout(function () {
                      var element = document.querySelector(".infobox");
                      element.scrollIntoView();
                    }, 200);
                  } else {
                    //console.log("0");
                    // Progress check
                    if (response.data.progress != 30 && !this.kit) {
                      _this.error = 'Wir haben keinen laufenden Auftrag zu diesem Kennzeichen gefunden.';
                      _this.loading = false;
                      // scroll down
                      setTimeout(function () {
                        var element = document.querySelector(".infobox");
                        element.scrollIntoView();
                      }, 200);
                      return;
                    }

                    // reset last slide text
                    _this.last_slide_title = 'Vielen Dank für Ihre Buchung!';
                    _this.last_slide_text = '';

                    // pass on...
                    //console.log("1");
                    //if(this.kit)
                    _this.licenseplateFound = true;
                    //else
                    //_this.licenseplateFound = false;
                    if (!_this.firstBookableSlot && response.data.firstBookableSlot) {
                      _this.firstBookableSlot = response.data.firstBookableSlot;
                    }
                    _this.typeDetails = response.data.typeDetails;
                    _this.progress = response.data.progress;
                    _this.progressInfo = response.data.progressInfo;
                    _this.current_employee_id = response.data.current_employee_id;
                    _this.availableEmployees = response.data.availableEmployees;
                    _this.selectedEmployeeId = response.data.initialEmployeeId;
                    _this.selectedJobId = response.data.jobId;
                    _this.jobId = response.data.jobId;
                    _this.selectedCompanyId = response.data.companyId;
                    _this.employeeSelect = response.data.employeeSelect;
                    _this.employeeSelectText = response.data.employeeSelectText;
                    _this.employeeSelectedText = response.data.employeeSelectedText;
                    _this.onlineOfferPartnerUrl = response.data.onlineOfferPartnerUrl;
                    _this.onlineOfferPartnerText = response.data.onlineOfferPartnerText;
                    _this.viewingAppointment = response.data.viewingAppointment;
                    _this.damageToken = response.data.damageToken;
                    //console.log("2");

                    //if(_this.employeeSelect == 0) {
                    //    _this.selectedEmployeeId = false;
                    //}

                    _this.attributes.available_dates = response.data.availableDates;

                    const tomorrowDate = new Date();
                    tomorrowDate.setDate(tomorrowDate.getDate() + 1);
                    const tomorrowStr = moment(tomorrowDate).format('YYYY-MM-DD');
                    _this.rangeAnchor = moment(tomorrowStr).toDate();

                    _this.attributes.max_date = new Date();
                    _this.attributes.max_date.setDate(
                        _this.attributes.min_date.getDate() + (_this.content.setting_maxdays_viewing || 30)
                    );

                    _this.min_date_range = new Date();
                    _this.max_date_range = new Date();
                    _this.min_date_range.setDate(_this.min_date_range.getDate() + 1);
                    _this.max_date_range.setDate(_this.min_date_range.getDate() + Math.min(_this.content.setting_maxdays_viewing || 30, 30));

                    // Cache full slots list and show first available day
                    _this.allSlots = response.data.slots || [];
                    const firstDate = (response.data.availableDates && response.data.availableDates[0]) || tomorrowStr;
                    _this.showSlotsForDay(firstDate, response.data);

                    _this.dropzoneOptions.url = '/api/ksr/upload/' + _this.studioId + '/' + response.data.jobId + '/' + response.data.requestId;

                    if (_this.kit && _this.licenseplate == 'k') {
                      _this.$refs.myVueDropzone1.dropzone.options.url = _this.dropzoneOptions.url; // update refs
                    }

                    _this.requestId = response.data.requestId;
                    //console.log("3");

                    if (!refresh) {
                      //this.$refs.carousel.next();
                    }
                    //this.step = 2;
                    _this.loading = false;
                    _this.loadingEmployeeCalender = false;

                    // scroll down
                    setTimeout(function () {
                      var element = document.querySelector(".infobox");
                      if (element) {
                        element.scrollIntoView();
                      }
                    }, 200);


                    if (jobId) {
                      _this.currentPage = false;
                      //console.log(_this.$refs.carousel);
                      _this.$refs.carousel.next();
                      _this.step = 3;
                    }

                  }

                });

          },

            onViewingAppointment() {
                this.hideSlick = false;
                this.onlineOffer = false;
                this.$refs.carousel.next();
                this.step = 2;
                setTimeout(function() {
                    var element = document.querySelector("#booking-container");
                    element.scrollIntoView();
                }, 200);
            },

            /*onViewingAppointmentWithJobId(licenseplate, jobId) {
                this.licenseplate = licenseplate;
                this.onLicensePlateInput(false, jobId);
                //this.onlineOffer = false;
                //this.$refs.carousel.next();
                //this.step = 2;
            },*/

            onViewingAppointmentFromJob() {
                this.rootSection = 'kl'; // important when called from child component
                this.hideSlick = false;
                //this.removeSingleJobTokenFromUrl(); // important when called from child component
                this.step = 1;
                this.onlineOffer = false;
                this.licenseplate = this.jobData.value.vehicle.registrationDetails.registrationPlate;
                if(!this.licenseplate) {
                    this.licenseplate = '0';
                }
                //console.log(this.jobId);
                this.onLicensePlateInput(false, this.jobId);
                //this.onlineOffer = false;
                //this.$refs.carousel.next();
                //this.step = 2;
                setTimeout(function() {
                    var element = document.querySelector("#booking-container");
                    element.scrollIntoView();
                }, 200);

            },

            onOnlineOffer() {
                this.onlineOffer = true;
                this.hideSlick = false;
                this.$refs.carousel.next();
                this.step = 2;
                this.formdata_offer.vehicleId = false;
                setTimeout(function() {
                    var element = document.querySelector("#booking-container");
                    element.scrollIntoView();
                }, 200);
            },

            /*onOnlineOfferWithJobId(jobId) {
                alert(jobId);
            },*/

            onOnlineOfferFromJob() {
                this.rootSection = 'kl'; // important when called from child component
                this.currentPage = false;
                this.onlineOffer = true;

                // update request id and dropzone options
                if(!this.requestId) {
                    this.requestId = crypto.randomUUID();
                }
                this.dropzoneOptions.url = '/api/ksr/upload/'+this.studioId+'/'+this.jobId+'/'+this.requestId;

                let foundRef = false;
                if(this.$refs.carousel) {
                    this.$refs.carousel.next();
                    foundRef = true;
                }
                // important when called from child component
                if(!foundRef) {
                    var _this = this;
                    setTimeout(function(){
                        _this.$refs.carousel.next();
                    }, 500);
                }
                this.step = 2;

                setTimeout(function() {
                    var element = document.querySelector("#booking-container");
                    element.scrollIntoView();
                }, 200);
            },

            onOnlineOfferDocuments() {
                this.rootSection = 'uploadDocuments'; // important when called from child component
            },

            onOnlineOfferDocumentsALT() {
                this.rootSection = 'kl'; // important when called from child component
                this.hideSlick = false;
                this.currentPage = false;
                this.onlineOffer = true;
                this.onlineOfferDocumentsOnly = true;

                // update request id and dropzone options
                if(!this.requestId) {
                    this.requestId = crypto.randomUUID();
                }
                this.dropzoneOptions.url = '/api/ksr/upload/'+this.studioId+'/'+this.jobId+'/'+this.requestId;

                /*let foundRef = false;
                if(this.$refs.carousel) {
                    this.$refs.carousel.next();
                    foundRef = true;
                }
                // important when called from child component
                if(!foundRef) {
                    var _this = this;
                    setTimeout(function(){
                        _this.$refs.carousel.next();
                    }, 500);
                }
                this.step = 2;
*/
                setTimeout(function() {
                    var element = document.querySelector("#booking-container");
                    element.scrollIntoView();
                }, 200);
            },

            onJobDetails(jobId) {

                this.step = 1;
                this.hideSlick = true;
                this.formdata_offer_errors = [];
                this.jobIdLoading = jobId;

                const tomorrow = new Date();
                tomorrow.setDate(tomorrow.getDate() + 1);
                let tomorrowStr = moment(String(tomorrow)).format('YYYY-MM-DD');

                let url = '/api/ksr/'+this.studioId+'/0/get-slots/?date='+tomorrowStr;
                url += '&jobId=' + jobId;
                url += '&identityToken='+this.identityToken;

                // force regenrate new request id for storing images
                this.requestId = crypto.randomUUID();

                var _this = this;
                this.loading = true;
                axios.get(url)
                .catch(function (error) {
                    // empty catch
                })
                .then((response) => {

                    _this.dropzoneOptions.url = '/api/ksr/upload/'+_this.studioId+'/'+jobId+'/'+_this.requestId;

                    _this.jobData = JSON.parse(response.data.jobData);
                    _this.jobId = jobId;
                    _this.loading = false;
                    _this.currentPage = 'jobDetails';
                    _this.jobIdLoading = false;

                    setTimeout(function() {
                        var element = document.querySelector("#booking-container");
                        element.scrollIntoView();
                    }, 200);
                });

            },

            // ========================
            // upload
            fileAdded(file) {
                //console.log("File Dropped => ", file);
                //console.log(file.dataURL);
                // Construct your file object to render in the UI
                let attachment = {};
                attachment._id = file.upload.uuid;
                attachment.title = file.name;
                attachment.type = "file";
                attachment.extension = "." + file.type.split("/")[1];
                //attachment.user = JSON.parse(localStorage.getItem("user"));
                attachment.content = "File Upload by Select or Drop";
                attachment.thumb = file.dataURL;
                attachment.thumb_list = file.dataURL;
                attachment.isLoading = true;
                attachment.progress = null;
                attachment.size = file.size;
                this.tempAttachments = [...this.tempAttachments, attachment];
                //console.log(this.tempAttachments);
            },
            /*updateThumb(file) {
                console.log("Update Thumb => ", file);
                console.log(file.dataURL);
                // Construct your file object to render in the UI
                let attachment = {};
                attachment._id = file.upload.uuid;
                attachment.title = file.name;
                attachment.type = "file";
                attachment.extension = "." + file.type.split("/")[1];
                //attachment.user = JSON.parse(localStorage.getItem("user"));
                attachment.content = "File Upload by Select or Drop";
                attachment.thumb = file.dataURL;
                attachment.thumb_list = file.dataURL;
                attachment.isLoading = true;
                attachment.progress = null;
                attachment.size = file.size;
                this.tempAttachments = [...this.tempAttachments, attachment];
                console.log(this.tempAttachments);
            },*/
            // a middle layer function where you can change the XHR request properties
            sendingFiles(files, xhr, formData) {
                //console.log("if you want to change the upload time or add data to the formData you can do it here.");
                //console.log("Files sending", files);
                //console.log(formData);
            },
            // function where we get the upload progress
            uploadProgress(file, progress, bytesSent) {
                //console.log("File Upload Progress", progress);
                this.tempAttachments.map(attachment => {
                if (attachment.title === file.name) {
                  attachment.progress = `${Math.floor(progress)}`;
                }
              });
            },
            // called on successful upload of a file
            success(file, response) {
                //console.log("File uploaded successfully");
                //console.log(file);

              //console.log("Response is ->", response);
              ////console.log(file);
              ////console.log(response);
              for(var i = 0; i < file.length; i++) {
                //console.log(file[i].upload.uuid);
                for(var k = 0; k < this.tempAttachments.length; k++) {
                    //console.log(this.tempAttachments[k]._id);
                    if(this.tempAttachments[k]._id == file[i].upload.uuid) {
                        //console.log("update");
                        this.tempAttachments[k].title = response[i];
                        this.tempAttachments[k].thumb = file[i].dataURL;
                        this.tempAttachments[k].thumb_list = file[i].dataURL;
                    }
                }
              }
            },
            fileAdded2(file) {
                //console.log("File Dropped => ", file);
                // Construct your file object to render in the UI
                let attachment = {};
                attachment._id = file.upload.uuid;
                attachment.title = file.name;
                attachment.type = "file";
                attachment.extension = "." + file.type.split("/")[1];
                //attachment.user = JSON.parse(localStorage.getItem("user"));
                attachment.content = "File Upload by Select or Drop";
                attachment.thumb = file.dataURL;
                attachment.thumb_list = file.dataURL;
                attachment.isLoading = true;
                attachment.progress = null;
                attachment.size = file.size;
                this.tempAttachments2 = [...this.tempAttachments2, attachment];
            },
            // a middle layer function where you can change the XHR request properties
            sendingFiles2(files, xhr, formData) {
                //console.log("if you want to change the upload time or add data to the formData you can do it here.");
                //console.log("Files sending", files);
                //console.log(formData);
            },
            // function where we get the upload progress
            uploadProgress2(file, progress, bytesSent) {
                //console.log("File Upload Progress", progress);
                this.tempAttachments2.map(attachment => {
                if (attachment.title === file.name) {
                  attachment.progress = `${Math.floor(progress)}`;
                }
              });
            },
            // called on successful upload of a file
            success2(file, response) {
              //console.log("File uploaded successfully");
              //console.log("Response is ->", response);
              for(var i = 0; i < file.length; i++) {
                //console.log(file[i].upload.uuid);
                for(var k = 0; k < this.tempAttachments2.length; k++) {
                    //console.log(this.tempAttachments2[k]._id);
                    if(this.tempAttachments2[k]._id == file[i].upload.uuid) {
                        this.tempAttachments2[k].title = response[i];
                        this.tempAttachments2[k].thumb = file[i].dataURL;
                        this.tempAttachments2[k].thumb_list = file[i].dataURL;
                    }
                }
              }
            },
            // ========================

            onSelectedEmployee() {
                this.loadingEmployeeCalender = true;
                this.onLicensePlateInput(true);
            },

            dayClicked(day) {
                if (this.content.setting_maxdays_viewing === 0) return;

                const dateStr = moment(day.id).format('YYYY-MM-DD');

                if (this.rangeAnchor) {
                    const rangeStart = moment(this.rangeAnchor);
                    const rangeEnd = moment(this.rangeAnchor).add(30, 'days');
                    const withinRange = moment(dateStr).isBetween(rangeStart, rangeEnd, 'day', '[]');

                    if (!withinRange) {
                        this.timSlotsloading = true;
                        this.rangeAnchor = moment(dateStr).toDate();
                        // re-fetch available dates for the new range window
                        const _this = this;
                        let url = '/api/ksr/' + this.studioId + '/' + encodeURIComponent(this.licenseplate) + '/get-slots/?date=' + dateStr;
                        if (this.selectedEmployeeId) url += '&employeeId=' + this.selectedEmployeeId;
                        if (this.jobId) url += '&jobId=' + this.jobId;
                        if (this.firstBookableSlot) url += '&firstBookableSlot=' + encodeURIComponent(this.firstBookableSlot);
                        url += '&identityToken=' + this.identityToken;
                        axios.get(url).then((response) => {
                            _this.attributes.available_dates = response.data.availableDates;
                            _this.allSlots = response.data.slots || [];
                            // Always honour the day the user actually clicked — never
                            // auto-jump to a different available day than what was selected.
                            if ((response.data.availableDates || []).includes(dateStr)) {
                                _this.showSlotsForDay(dateStr, response.data);
                            } else {
                                const maxDate = _this.attributes.max_date;
                                const nextAvail = (response.data.availableDates || []).find(d =>
                                    moment(d).isSameOrAfter(moment(dateStr), 'day') &&
                                    (!maxDate || moment(d).isSameOrBefore(moment(maxDate), 'day'))
                                );
                                if (nextAvail) {
                                    _this.showSlotsForDay(moment(nextAvail).format('YYYY-MM-DD'), response.data);
                                } else {
                                    _this.selectedDate = new Date(dateStr);
                                    _this.availableSlots = Object.assign({}, response.data, { slots: [], selectedDate: dateStr });
                                }
                            }
                            _this.timSlotsloading = false;
                        }).catch(() => { _this.timSlotsloading = false; });
                        return;
                    }
                }

                if (this.attributes.available_dates && this.attributes.available_dates.length > 0) {
                    if (!this.attributes.available_dates.includes(dateStr)) {
                        // Day has no free slots — show the empty-state message and stay
                        // on the clicked day instead of jumping to the next available one.
                        this.showSlotsForDay(dateStr);
                        return;
                    }
                }

                // Try cache first; fall back to API if the cached slots don't cover this day
                const cachedForDay = (this.allSlots || []).filter(s => moment(s.start).format('YYYY-MM-DD') === dateStr);
                if (cachedForDay.length > 0) {
                    this.showSlotsForDay(dateStr);
                } else {
                    this.fetchSlotsForDay(dateStr);
                }
            },

            showSlotsForDay(dateStr, baseData) {
                const slotsForDay = (this.allSlots || []).filter(s => moment(s.start).format('YYYY-MM-DD') === dateStr);
                this.availableSlots = Object.assign({}, baseData || this.availableSlots || {}, {
                    slots: slotsForDay,
                    selectedDate: dateStr
                });
                this.selectedDate = new Date(dateStr);
                this.timSlotsloading = false;
                const cal = this.$refs.datepicker && this.$refs.datepicker.$refs.calendar;
                if (cal) cal.move(new Date(dateStr));
            },

            fetchSlotsForDay(dateStr) {
                this.timSlotsloading = true;
                var _this = this;
                let url = '/api/ksr/' + this.studioId + '/' + encodeURIComponent(this.licenseplate) + '/get-slots/?date=' + dateStr;
                if (this.selectedEmployeeId) {
                    url += '&employeeId=' + this.selectedEmployeeId;
                }
                if (this.jobId) {
                    url += '&jobId=' + this.jobId;
                }
                if (this.firstBookableSlot) url += '&firstBookableSlot=' + encodeURIComponent(this.firstBookableSlot);
                url += '&identityToken=' + this.identityToken;

                axios.get(url)
                .catch(function (error) {
                    if (error.response && error.response.status === 404) {
                        _this.availableSlots = { slots: [], selectedDate: dateStr };
                        _this.selectedDate = new Date(dateStr);
                    }
                    _this.timSlotsloading = false;
                })
                .then((response) => {
                    if (!response) return;
                    if (response.data.availableDates) {
                        _this.attributes.available_dates = response.data.availableDates;
                    }
                    if (response.data.slots) {
                        _this.allSlots = response.data.slots;
                    }
                    const targetDay = moment(response.data.selectedDate || dateStr).format('YYYY-MM-DD');
                    _this.showSlotsForDay(targetDay, response.data);
                });
            },

            onSlotsSelected() { // last step

                if(this.kit && this.licenseplate == 'k') {

                    this.formdata_errors = [];

                    if(this.formdata.licenseplate == '' && this.formdata.vehicleId == '') {
                        this.formdata_errors.push('licenseplate');
                    }

                    if(this.formdata.brand == '' && this.formdata.vehicleId == '') {
                        this.formdata_errors.push('brand');
                    }

                    if(this.formdata.model == '' && this.formdata.vehicleId == '') {
                        this.formdata_errors.push('model');
                    }

                    if(this.formdata.description == '') {
                        this.formdata_errors.push('description');
                    }

                    if(this.formdata.infos == '') {
                        this.formdata_errors.push('infos');
                    }

                }

                // scroll to top
                if(this.formdata_errors.length) {
                    //var element = document.querySelector("#booking-container");
                    //element.scrollIntoView();
                    setTimeout(function() {
                        var element = document.querySelector(".invalid-feedback");
                        element.scrollIntoView();
                    }, 200);
                }

                if(!this.formdata_errors.length) {

                    this.$refs.carousel.next();
                    this.step = 3;

                    // scroll to top
                    //var element = document.querySelector("#booking-container");
                    //element.scrollIntoView();
                    setTimeout(function() {
                        var element = document.querySelector("#booking-container");
                        element.scrollIntoView();
                    }, 200);

                    // set selectedEmployee
                    var _this = this;
                    this.availableEmployees.forEach (function (employee, index) {
                        if(employee.id == _this.selectedEmployeeId) {
                            _this.selectedEmployee = employee.text;
                        }
                    });

                }
            },

            onSelectSlot(slot) {
                //console.log(slot);
                this.selectedSlotIds = []
                this.selectedSlots = [];
                this.selectedSlotIds.push(slot.id);
                this.selectedSlots.push(slot);

                //if(this.employeeSelect == 0) {
                    this.selectedEmployeeId = slot.availableEmployees[0];
                //}

                /*const index = this.selectedSlotIds.indexOf(slot.id);
                if(index === -1) {
                    this.selectedSlotIds.push(slot.id);
                    this.selectedSlots.push(slot);
                    console.log("1");
                }
                else { // remove
                    this.selectedSlotIds.splice(index, 1);
                    console.log(slot.id);
                    for (let index = 0; index < this.selectedSlots.length; ++index) {
                        if(this.selectedSlots[index].id == slot.id) {
                            this.selectedSlots.splice(index, 1);
                        }
                    }
                }*/
            },

            onBookNow() {

                this.loading = true;
                var _this = this;

                var data = {
                    start: this.selectedSlots[0].start,
                    employeeId: this.selectedEmployeeId,
                    jobId: this.selectedJobId,
                    companyId: this.selectedCompanyId
                }

                axios.post('/api/ksr/'+this.studioId+'/confirm?identityToken='+this.identityToken, data)
                .catch(function (error) {
                    // empty catch
                })
                .then((response) => {
                    _this.$refs.carousel.next();
                    _this.step = 3;
                    _this.loading = false;
                });

            },

            onDeleteViewingAppointment() {

                setTimeout(function() {
                    var element = document.querySelector("#booking-container");
                    element.scrollIntoView();
                }, 200);

                this.last_slide_title = 'Vielen Dank!';
                this.last_slide_text = 'Wir haben Ihren Termin storniert.';

                this.loading = true;
                var _this = this;

                var data = {
                    jobId: this.selectedJobId,
                    companyId: this.selectedCompanyId
                }

                axios.post('/api/ksr/'+this.studioId+'/delete?identityToken='+this.identityToken, data)
                .catch(function (error) {
                    // empty catch
                })
                .then((response) => {
                    _this.$refs.carousel.goTo(3, true);
                    _this.step = 3;
                    _this.loading = false;
                });

            },

            onRequestOffer() {

                this.formdata_offer_errors = [];

                if(this.kit && this.licenseplate == 'k') {

                    if(this.formdata_offer.licenseplate == '') {
                        this.formdata_offer_errors.push('licenseplate');
                    }

                    if(this.formdata_offer.vin == '') {
                        this.formdata_offer_errors.push('vin');
                    }

                    if(this.formdata_offer.brand == '') {
                        this.formdata_offer_errors.push('brand');
                    }

                    if(this.formdata_offer.model == '') {
                        this.formdata_offer_errors.push('model');
                    }

                    if(this.formdata_offer.vehicleId == '') {
                        this.formdata_offer_errors.push('vehicleId');
                    }

                    //if(this.formdata_offer.damageId == '') {
                    //    this.formdata_offer_errors.push('damageId');
                    //}

                    if(this.formdata_offer.description == '') {
                        this.formdata_offer_errors.push('description');
                    }

                }

                /*if(this.formdata_offer.description == '') {
                    this.formdata_offer_errors.push('description');
                }*/

                if(this.formdata_offer.infos == '') {
                    this.formdata_offer_errors.push('infos');
                }

                //console.log("test2");

                let uploadDocumentsChildFormdata = this.$refs.uploadDocumentsChild.formdata;
                if(this.content.setting_onlineoffer_damage_required) {
                    if(!uploadDocumentsChildFormdata.damageId || uploadDocumentsChildFormdata.damageId == '') {
                        this.formdata_offer_errors.push('damageId');
                        this.formdata_offer_errors.push('damage_images');
                    }
                }
                if(this.content.setting_onlineoffer_registration_required) {
                    if(uploadDocumentsChildFormdata.files_registration.length == 0) {
                      this.formdata_offer_errors.push('registration');
                      this.formdata_offer_errors.push('registration_document');
                    }
                }

                //console.log("test3");


                //if(!this.tempAttachments.length && !this.kit) {
                //    this.formdata_offer_errors.push('images01');
                //}
                //if(!this.tempAttachments2.length && !this.kit) {
                //    this.formdata_offer_errors.push('images02');
                //}

                // scroll to top
                if(this.formdata_offer_errors.length) {
                    //var element = document.querySelector("#booking-container");
                    //element.scrollIntoView();
                    setTimeout(function() {
                        var element = document.querySelector(".invalid-feedback");
                        element.scrollIntoView();
                    }, 200);
                }

                //console.log("test4");
                //console.log(this.formdata_offer_errors);

                if(!this.formdata_offer_errors.length) {

                    this.loading = true;
                    var _this = this;

                   // console.log("test5");

                    if(this.kit && this.licenseplate == 'k') {

                        var data = {
                            requestId: this.requestId,
                            tempAttachments: this.tempAttachments,
                            tempAttachments2: this.tempAttachments2,
                            formdata_offer: this.formdata_offer,
                            formdata: this.formdata_offer,
                            insuranceData: this.insuranceData
                        };

                        axios.post('/api/ksr/'+this.studioId+'/offer/kit/confirm?identityToken='+this.identityToken, data)
                        .catch(function (error) {
                            // empty catch
                        })
                        .then((response) => {

                            // Attach Documents to damage
                            let uploadDocumentsChildFormdata = this.$refs.uploadDocumentsChild.formdata;
                            let jobId = response.data;

                            console.log(uploadDocumentsChildFormdata);
                            console.log(jobId);

                            uploadDocumentsChildFormdata.jobId = jobId;
                            if(uploadDocumentsChildFormdata && jobId) {

                                let data = {
                                    formdata: uploadDocumentsChildFormdata,
                                    suppressMail: true
                                }
                                axios.post('/api/ksr/upload/documents/send?identityToken='+this.identityToken, data)
                                .then((response) => {
                                    _this.$refs.carousel.goTo(3, true);
                                    _this.step = 3;
                                    _this.loading = false;
                                    _this.formdata_offer_errors = [];
                                    _this.$refs.uploadDocumentsChild.formdata.files_registration = [];
                                    _this.$refs.uploadDocumentsChild.resetChild();
                                    setTimeout(function() {
                                        var element = document.querySelector("#booking-container");
                                        element.scrollIntoView();
                                    }, 200);
                                });
                            }
                            else {
                                _this.$refs.carousel.goTo(3, true);
                                _this.step = 3;
                                _this.loading = false;
                                _this.formdata_offer_errors = [];
                                setTimeout(function() {
                                    var element = document.querySelector("#booking-container");
                                    element.scrollIntoView();
                                }, 200);
                            }

                        });

                    }
                    else { // ohne auth

                        var data = {
                            jobId: this.selectedJobId,
                            requestId: this.requestId,
                            tempAttachments: this.tempAttachments,
                            tempAttachments2: this.tempAttachments2,
                            formdata_offer: this.formdata_offer
                        };

                        axios.post('/api/ksr/'+this.studioId+'/offer/confirm?identityToken='+this.identityToken, data)
                        .catch(function (error) {
                            // empty catch
                        })
                        .then((response) => {
                            // Attach Documents to damage
                            let uploadDocumentsChildFormdata = this.$refs.uploadDocumentsChild.formdata;
                            let jobId = response.data;
                            uploadDocumentsChildFormdata.jobId = jobId;
                            if(uploadDocumentsChildFormdata && jobId) {
                                let data = {
                                    formdata: uploadDocumentsChildFormdata,
                                    suppressMail: true
                                }
                                axios.post('/api/ksr/upload/documents/send?identityToken='+this.identityToken, data)
                                .then((response) => {
                                    _this.$refs.carousel.goTo(3, true);
                                    _this.step = 3;
                                    _this.loading = false;
                                    _this.formdata_offer_errors = [];
                                    _this.$refs.uploadDocumentsChild.formdata.files_registration = [];
                                    _this.$refs.uploadDocumentsChild.resetChild();
                                    setTimeout(function() {
                                        var element = document.querySelector("#booking-container");
                                        element.scrollIntoView();
                                    }, 200);
                                });
                            }
                        });

                    }

                }
            },

            onUpdateJob() {

                // scroll to top
                if(this.formdata_offer_errors.length) {
                    //var element = document.querySelector("#booking-container");
                    //element.scrollIntoView();
                    setTimeout(function() {
                        var element = document.querySelector(".invalid-feedback");
                        element.scrollIntoView();
                    }, 200);
                }

                this.loading = true;

                //if(this.kit && this.licenseplate == 'k') {
                if(this.kit) {

                    var _this = this;

                    var data = {
                        jobId: this.jobId,
                        requestId: this.requestId,
                        tempAttachments: this.tempAttachments,
                        tempAttachments2: this.tempAttachments2,
                        formdata_offer: this.formdata_offer
                    };

                    axios.post('/api/ksr/'+this.studioId+'/offer/confirm?identityToken='+this.identityToken, data)
                    .catch(function (error) {
                        // empty catch
                    })
                    .then((response) => {
                        _this.$refs.carousel.goTo(3, true);
                        _this.step = 3;
                        _this.loading = false;
                        _this.jobId = '';
                    });

                }

            },

            onUploadDocuments() {

                this.loading = true;

                if(this.kit && this.licenseplate == 'k' || this.jobId) {

                    if(!this.requestId) {
                        this.requestId = crypto.randomUUID();
                    }

                    var data = {
                        requestId: this.requestId,
                        tempAttachments: this.tempAttachments,
                        tempAttachments2: this.tempAttachments2,
                        jobId: this.jobId,
                        formdata_offer: this.formdata_offer
                    };

                    var _this = this;
                    axios.post('/api/ksr/'+this.studioId+'/offer/kit/confirm?identityToken='+this.identityToken, data)
                    .catch(function (error) {
                        // empty catch
                    })
                    .then((response) => {
                        _this.$refs.carousel.goTo(3, true);
                        _this.step = 3;
                        _this.loading = false;
                    });

                }

            },

            onBookNowKit() {

                //if(this.formdata.description == '') {
                //    this.formdata_errors.push('description');
                //}

                if(this.formdata.infos == '') {
                    this.formdata_errors.push('infos');
                }

                // scroll to top
                if(this.formdata_errors.length) {
                    //var element = document.querySelector("#booking-container");
                    //element.scrollIntoView();
                    setTimeout(function() {
                        var element = document.querySelector(".invalid-feedback");
                        element.scrollIntoView();
                    }, 200);
                }

                if(!this.formdata_errors.length) {

                    this.loading = true;
                    var _this = this;

                    var data = {
                        requestId: this.requestId,
                        tempAttachments: this.tempAttachments,
                        tempAttachments2: this.tempAttachments2,
                        formdata: this.formdata,
                        start: this.selectedSlots[0].start,
                        employeeId: this.selectedEmployeeId,
                        insuranceData: this.insuranceData
                    };

                    //var xsrf = this.$cookies.get("XSRF-TOKEN");
                    //Axios.defaults.headers.common['X-CSRF-TOKEN'] = xsrf;

                    axios.post('/api/ksr/'+this.studioId+'/kit/confirm?identityToken='+this.identityToken, data)
                    .catch(function (error) {
                        // empty catch
                    })
                    .then((response) => {
                        //console.log(response);
                        _this.$refs.carousel.goTo(3, true);
                        _this.step = 3;
                        _this.loading = false;
                    });

                }

            },

            openLoginWindow(section = 'kl') {
                var w = 400;
                var h = 500;
                var left = (screen.width/2)-(w/2);
                var top = (screen.height/2)-(h/2);
                var addSectionToUrl = '';
                if(section == 'service') {
                    //var addSectionToUrl = '&section=service';
                }
                //https://pre.booklyn.io/s/ksrdemo.booklyn.io/ksrlogin/1
                if(window.location.href.indexOf("/s/") != -1) {
                    //window.open('/s/pre.booklyn.io/ksrlogin/' + this.studioId + addSectionToUrl, 'ksrlogin', 'toolbar=no, location=no, directories=no, status=no, menubar=no, scrollbars=no, resizable=no, copyhistory=no, width='+w+', height='+h+', top='+top+', left='+left);
                    window.open('/s/pre.booklyn.io/ksrlogin/' + this.studioId + '?cookieless' + addSectionToUrl, 'ksrlogin', 'toolbar=no, location=no, directories=no, status=no, menubar=no, scrollbars=no, resizable=no, copyhistory=no, width='+w+', height='+h+', top='+top+', left='+left);
                }
                else {
                    //window.open('/ksrlogin/' + this.studioId + addSectionToUrl, 'ksrlogin', 'toolbar=no, location=no, directories=no, status=no, menubar=no, scrollbars=no, resizable=no, copyhistory=no, width='+w+', height='+h+', top='+top+', left='+left);
                    window.open('/ksrlogin/' + this.studioId + '?cookieless' + addSectionToUrl, 'ksrlogin', 'toolbar=no, location=no, directories=no, status=no, menubar=no, scrollbars=no, resizable=no, copyhistory=no, width='+w+', height='+h+', top='+top+', left='+left);
                }
            },

            logout() {
                var uri = window.location.href.split("#")[0];
                var hash = window.location.hash;

                var href = new URL(uri);
                href.searchParams.delete("t");
                var newUri = href.toString();

                sessionStorage.removeItem('identityToken');
                this.identityToken = false;

                window.location.href = newUri + '?ksrlogout';
            },

            slotActive(slot_id) {
                if(this.selectedSlotIds.indexOf(slot_id) > -1)
                    return true;
                else
                    return false;
            },

            onStepPrev() {
                this.step = this.step - 1;
                this.$refs.carousel.goTo(this.step - 1);
                if(this.step == 1) {
                    this.selectedService = '';
                }
            },

            /*bookNow() {
                axios.post('/api/studio/' + this.studioId + '/book?identityToken='+this.identityToken, this.$data)
                .then(function (response) {
                    if(response.status == 200) {
                        window.location.href = "/booking-request/" + response.data;
                    }
                });
            },*/

            onEditAccount() {
                this.rootSection = 'kl';
                this.hideSlick = false;
                this.currentPage = false;
                this.editAccount = true;
            },

            onCancelAccount() {
                this.editAccount = false;
            },

            onAccount() {
                return;
            },

            onCreateAccount() {

                this.formdata_errors_account = [];
                if(this.accountInfo.firstName == '') {
                    this.formdata_errors_account.push('firstName');
                }
                if(this.accountInfo.lastName == '') {
                    this.formdata_errors_account.push('lastName');
                }
                if(this.accountInfo.street == '') {
                    this.formdata_errors_account.push('street');
                }
                if(this.accountInfo.zipCode == '') {
                    this.formdata_errors_account.push('zipCode');
                }
                if(this.accountInfo.city == '') {
                    this.formdata_errors_account.push('city');
                }

                // scroll to top
                if(this.formdata_errors_account.length) {
                    //var element = document.querySelector("#booking-container");
                    //element.scrollIntoView();
                    setTimeout(function() {
                        var element = document.querySelector(".invalid-feedback");
                        element.scrollIntoView();
                    }, 200);
                }

                if(!this.formdata_errors_account.length) {
                    this.loading = true;
                    var _this = this;
                    axios.put('/api/ksr/' + this.studioId + '/account?identityToken='+this.identityToken, this.$data.accountInfo)
                    .catch(function (error) {
                        _this.loading = false;
                        _this.formdata_errors_account.push('api');
                        //alert("Es gab einen Fehler beim Speichern Ihrer Daten.");
                    })
                    .then(function (response) {
                        if(response.status == 200) {
                            location.reload();
                        }
                        _this.loading = false;
                    });
                }
            },

            onUpdateAccount() {

                this.formdata_errors_account = [];
                if(this.accountInfo.firstName == '') {
                    this.formdata_errors_account.push('firstName');
                }
                if(this.accountInfo.lastName == '') {
                    this.formdata_errors_account.push('lastName');
                }
                if(this.accountInfo.street == '') {
                    this.formdata_errors_account.push('street');
                }
                if(this.accountInfo.zipCode == '') {
                    this.formdata_errors_account.push('zipCode');
                }
                if(this.accountInfo.city == '') {
                    this.formdata_errors_account.push('city');
                }

                // scroll to top
                if(this.formdata_errors_account.length) {
                    //var element = document.querySelector("#booking-container");
                    //element.scrollIntoView();
                    setTimeout(function() {
                        var element = document.querySelector(".invalid-feedback");
                        element.scrollIntoView();
                    }, 200);
                }

                if(!this.formdata_errors_account.length) {
                    this.loading = true;
                    var _this = this;
                    axios.post('/api/ksr/' + this.studioId + '/account?identityToken='+this.identityToken, this.$data.accountInfo)
                    .catch(function (error) {
                        _this.loading = false;
                        _this.formdata_errors_account.push('api');
                        //alert("Es gab einen Fehler beim Speichern Ihrer Daten.");
                    })
                    .then(function (response) {
                        if(response.status == 200) {
                            location.reload();
                        }
                        _this.loading = false;
                    });
                }
            },

            reload() {
                location.reload();
            },

            gotoFirstSlide() {
                if(this.step != 0 && this.$refs.carousel) {
                    this.$refs.carousel.goTo(0, true);
                    this.step = 1;
                }
            },

            kitOnNewRequest() {
                this.rootSection = 'kl';
                this.editAccount = false;
                this.currentPage = false;
                this.jobId = false;
                this.selectedJobId = false;
                this.jobData = {};
                this.licenseplate = 'k';
                this.licenseplateFound = false;
                this.kitShowLicensePlateInput = false;
                this.insuranceData = false;
                this.initInsuranceData = Math.random();
                this.viewingAppointment = false;
                this.hideSlick = false;
                this.gotoFirstSlide();

                // get client vehicles
                var _this = this;
                axios.get('/api/ksr/vehicles?identityToken='+this.identityToken)
                .then((response) => {
                    _this.clientVehicles = response.data;
                });
            },

            kitOnService() {
              if(this.accountStatus == 10) {
                this.onEditAccount();
              }
              else {
                this.$router.push('/'); // back to root
                this.rootSection = 'mechanik';
                this.currentPage = ''
                this.service_reload++;
              }
            },

            kitOnListCurrentJobs() {
              if(this.accountStatus == 10) {
                this.onEditAccount();
              }
              else {
                this.$router.push('/'); // back to root
                this.currentPage = 'currentJobs';
                this.rootSection = 'kl';
                this.step = 1;
                this.insuranceData = false;
                this.accountInfoJobs = false;
                this.loading = true;
                var _this = this;
                // Check User Status and get current Jobs
                let url = '/api/ksr/'+this.studioId+'/userstatus?identityToken='+this.identityToken;
                axios.get(url)
                .catch(function (error) {
                    // empty catch
                })
                .then((response) => {
                    _this.accountInfoJobs = response.data.jobs;
                    _this.loading = false;
                });
              }
            },

            kitOnListVehicles() {

            },

            kitOnListPastJobs() {
                this.currentPage = 'pastJobs';
            },

            kitOnSearchNumberPlate() {
                this.gotoFirstSlide();

                this.editAccount = false;
                this.currentPage = false;

                this.licenseplate = '';
                this.licenseplateFound = false;
                this.kitShowLicensePlateInput = true;
            },

            getInsuranceData(value) {
                console.log(value);
                //console.log(value.damagetype);
                this.insuranceData = value;
            },

            updatejobdata(jobdata) {
                //console.log("emit found");
                //console.log(jobdata);
                this.hideFirstPage = true;
                this.licenseplateFound = true;
                this.jobId = jobdata.jobId;
                this.selectedJobId = this.jobId;
                this.jobData = jobdata;
            },

            getVehicleById(vehicleId) {
                let str = '';
                this.accountInfoVehicles.value.forEach (function (vehicle, index) {
                    if(vehicle.vehicleKey.id == vehicleId) {
                        str = vehicle.manufacturer + ' ' + vehicle.type + ' ' + vehicle.model + ' ' + vehicle.licensePlate;
                    }
                });
                return str;
            },

            setVehicle(vehicle) {

                if(!vehicle) {
                    this.formdata.brand = '';
                    this.formdata.model = '';
                    this.formdata.ez = '';
                    this.formdata.licenseplate = '';
                    this.formdata.vin = '';
                    this.formdata.vehicleId = false
                    this.formdata_offer.brand = '';
                    this.formdata_offer.model = '';
                    this.formdata_offer.ez = '';
                    this.formdata_offer.licenseplate = '';
                    this.formdata_offer.vin = '';
                    this.formdata_offer.vehicleId = false;
                }

                this.formdata.brand = vehicle.brand;
                this.formdata.model = vehicle.model;
                if(vehicle.registration_date) {
                    this.formdata.ez = moment(vehicle.registration_date).format('YYYY-MM-DD');
                }
                this.formdata.licenseplate = vehicle.licenseplate;
                this.formdata.vin = vehicle.vin;
                this.formdata.vehicleId = vehicle.id;

                this.formdata_offer.brand = vehicle.brand;
                this.formdata_offer.model = vehicle.model;
                this.formdata_offer.ez = moment(vehicle.registration_date).format('YYYY-MM-DD');
                this.formdata_offer.licenseplate = vehicle.licenseplate;
                this.formdata_offer.vin = vehicle.vin;
                this.formdata_offer.vehicleId = vehicle.id;

            },

            setDamage(damage) {
                this.formdata.damageId = damage.id;
                this.formdata_offer.damageId = damage.id;

            },

            // Accessibility Check (@ms, added 2025-02-10)
            observeSlides() {
                console.log("observing slides");
                const observer = new MutationObserver((mutations) => {
                    mutations.forEach((mutation) => {
                        if (mutation.attributeName === "aria-hidden") {
                            const slide = mutation.target;
                            this.updateFocusableElements(slide);
                        }
                    });
                });

                const slides = document.querySelectorAll(".slick-slide");
                slides.forEach((slide) => {
                    observer.observe(slide, { attributes: true });
                    this.updateFocusableElements(slide); // Initial update
                });
            },
            updateFocusableElements(slide) {
                console.log("updating focus elements for " + slide);
                const isHidden = slide.getAttribute("aria-hidden") === "true";
                const focusableElements = slide.querySelectorAll("button, a, input, textarea, select");

                focusableElements.forEach((el) => {
                    if (isHidden) {
                        el.setAttribute("tabindex", "-1");
                    } else {
                        el.removeAttribute("tabindex");
                    }
                });
            },

            isDamageWindowOpen(value) {
              this.hideSubmitButtonOnlineOffer = value;
            },

            // Guest Appointment, introduced 2025-07

            onSlotsSelectedGuest() {
              // Update 2025-07-27: Guest Booking (shows Insurance and Guest options after Viewing Appointment)
              this.rootSection = 'guestBookingViewingAppointment';
              setTimeout(function() {
                var element = document.querySelector("#booking-container");
                element.scrollIntoView();
              }, 200);
            },

            getInsuranceDataCheckout(value) {

              console.log(value);
              //console.log(value.damagetype);
              this.insuranceData = value;

              // save in local storage
              localStorage.setItem('selectedSlotStart', this.selectedSlots[0]?.start || '');
              localStorage.setItem('licensePlate', this.licenseplate || '');
              localStorage.setItem('typeDetails', JSON.stringify(this.typeDetails || {}));
              localStorage.setItem('insuranceData', JSON.stringify(this.insuranceData || {}));

              this.rootSection = '';
              this.$router.push('/viewing-appointment-checkout/' + this.jobId);
              /*this.$router.push({
                path: '/viewing-appointment-checkout',
                query: { jobId: this.jobId }
              });*/
            },

            /*goToGuestAppointment() {
              this.rootSection = '';
              this.$router.push('/guest-appointment')
              //window.location.hash = '#/guest-appointment'
              //const currentPath = window.location.pathname
              //window.location.href = currentPath + '/guest-appointment'
            },*/

            goToKSRViewingAppointment() {
              this.rootSection = '';
              this.$router.push('/viewing-appointment');
            },

            goToKSROnlineOffer() {
              this.rootSection = '';
              this.$router.push('/online-offer');
            },

            getIdentityTokenFromUrl() {
              // Check regular URL params first
              const urlParams = new URLSearchParams(window.location.search);
              const tokenFromSearch = urlParams.get('identityToken');

              // If not found, check Vue Router query params (for hash-based routing)
              const tokenFromRoute = this.$route.query.identityToken;

              return tokenFromSearch || tokenFromRoute;
            },

            setIdentityToken(token) {
              sessionStorage.setItem('identityToken', token);
              this.identityToken = token;
            },

            removeIdentityTokenFromUrl() {
              // Remove from regular URL params if present
              const urlParams = new URLSearchParams(window.location.search);
              if (urlParams.has('identityToken')) {
                urlParams.delete('identityToken');
                const fragment = window.location.hash;
                history.replaceState(null, '', '?' + urlParams + fragment);
              }

              // Remove from Vue Router query params if present
              if (this.$route.query.identityToken) {
                const newQuery = { ...this.$route.query };
                delete newQuery.identityToken;

                this.$router.replace({
                  path: this.$route.path,
                  query: newQuery
                });
              }
            }

        },

        props: ['studioId'],

    }
</script>

<style scoped>
.trim-cal-last-week >>> .vc-weeks > *:nth-child(n+43) {
  display: none !important;
}

.booking-info-box {
  display: flex;
  align-items: center;
  gap: 0.625rem;
  padding: 0.75rem 1rem;
  margin-bottom: 1rem;
  background: linear-gradient(135deg, #f0f7ff 0%, #e6f2ff 100%);
  border-left: 3px solid #3b82f6;
  border-radius: 6px;
  color: #1e3a5f;
  font-size: 0.9rem;
  line-height: 1.4;
}

.booking-info-icon {
  flex-shrink: 0;
  width: 18px;
  height: 18px;
  color: #3b82f6;
}

.booking-info-box strong {
  color: #1e3a5f;
  font-weight: 600;
}

.slot-loading-container {
  display: flex;
  justify-content: center;
  padding: 1rem 0;
}

.slot-spinner {
  width: 24px;
  height: 24px;
  border: 3px solid #f3f3f3;
  border-top: 3px solid #007bff;
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

/* Flatten the start/end cap circles of the booking range into the strip */
::v-deep .vc-booking-range-hl {
  background-color: #e8f0fe !important;
  border-radius: 0 !important;
  border-width: 0 !important;
  border-color: transparent !important;
}

/* Keep the day number readable on the start/end caps */
::v-deep .vc-booking-range-content {
  color: inherit !important;
}

/* Hide the highlight background for out-of-range dates */
::v-deep .vc-oor-hl {
  background-color: transparent !important;
  border-color: transparent !important;
  border-width: 0 !important;
}

/* Fade and disable out-of-range day numbers.
   color: inherit defeats v-calendar's default `vc-text-white` on the start cap
   of any range — without it, the first after-max day (and the last before-min day)
   render as white-on-white and disappear. Same neutralizer as .vc-booking-range-content. */
::v-deep .vc-oor {
  opacity: 0.2 !important;
  color: inherit !important;
  cursor: default !important;
  pointer-events: none !important;
}

/* v-calendar's default theme sets opacity:0 on the day wrapper for prev/next-month
   preview cells, which would collapse our .vc-oor fade to fully invisible. Re-show
   the wrapper so the .vc-oor opacity above governs out-of-range cells uniformly. */
::v-deep .vc-day:has(.vc-oor) > .vc-h-full {
  opacity: 1 !important;
}

/* Hide the highlight used only to attach vc-unavailable class */
::v-deep .vc-unavail-hl {
  background-color: transparent !important;
  border-color: transparent !important;
  border-width: 0 !important;
}

/* Same color: inherit neutralizer as .vc-oor / .vc-booking-range-content. Each entry in
   the unavailable-in-range date array is rendered with v-calendar's solid fillMode, which
   sets `vc-text-white` on the day content — invisible on the page and on the selected-day
   circle. Without this rule a selected unavailable day renders as a blue dot with no number. */
::v-deep .vc-unavailable {
  color: inherit !important;
}

/* Target the full day cell container via :has() */
::v-deep .vc-day:has(.vc-unavailable),
::v-deep .vc-day:has(.vc-oor) {
  cursor: default !important;
  pointer-events: none !important;
}
</style>
